/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@bytescale/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/***/ (function(module) {



var stylesInDOM = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };

    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);

  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }

      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };

  return updater;
}

module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();

        stylesInDOM.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ "./node_modules/@bytescale/style-loader/dist/runtime/insertStyleElement.js":
/***/ (function(module) {



/* istanbul ignore next  */
function insertStyleElement(options) {
  if (typeof document === "undefined") {
    return undefined;
  }

  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}

module.exports = insertStyleElement;

/***/ }),

/***/ "./node_modules/@bytescale/style-loader/dist/runtime/setAttributesWithoutAttributes.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;

  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}

module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ "./node_modules/@bytescale/style-loader/dist/runtime/styleDomAPI.js":
/***/ (function(module) {



/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";

  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }

  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }

  var needLayer = typeof obj.layer !== "undefined";

  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }

  css += obj.css;

  if (needLayer) {
    css += "}";
  }

  if (obj.media) {
    css += "}";
  }

  if (obj.supports) {
    css += "}";
  } // const sourceMap = obj.sourceMap;
  //
  // if (sourceMap && typeof btoa !== "undefined") {
  //   // This line appears to cause an internal server error from Vercel during builds (at least for the Shopify Vercel
  //   // template, which deploys to Vercel Edge functions), so we simply disable source maps to allow projects that
  //   // use "uploader" to build successfully.
  //   css += '\n/*# sourceMappingURL=data:application/json;base64,';
  //
  //   css += btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  //   css += ' */';
  // }
  // For old IE

  /* istanbul ignore if  */


  options.styleTagTransform(css, styleElement, options.options);
}

function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }

  styleElement.parentNode.removeChild(styleElement);
}
/* istanbul ignore next  */


function domAPI(options) {
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}

module.exports = domAPI;

/***/ }),

/***/ "./node_modules/@bytescale/style-loader/dist/runtime/styleTagTransform.js":
/***/ (function(module) {



/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement === undefined) {
    return;
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }

    styleElement.appendChild(document.createTextNode(css));
  }
}

module.exports = styleTagTransform;

/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/modal/Modal.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__body{overflow:hidden}.upload-widget--with-modal{-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;display:-webkit-flex;display:-moz-box;display:flex;position:fixed;top:0;bottom:0;left:0;right:0;z-index:99999}.upload-widget__modal{background:var(--shade-900);border-radius:.5em;z-index:100000;position:relative;overflow:auto;top:-5%;height:60%;width:75%;max-width:65.625em;max-height:41.25em}@media (max-height: 700px){.upload-widget__modal{top:-1%;height:80%}}.upload-widget__modal__close{position:absolute;right:0;top:0;z-index:2}.upload-widget__modal__close a{-moz-transition:0.1s color linear;transition:0.1s color linear;color:var(--shade-500);padding:1.125em 1.0625em .8125em .875em;display:inline-block}.upload-widget--full-screen .upload-widget__modal{top:0;height:100%;width:100%;max-width:none;max-height:none;border-radius:0}.upload-widget__backdrop{content:\" \";background:rgba(0,0,0,0.5);position:fixed;left:0;right:0;top:0;bottom:0;z-index:99999}.upload-widget__modal,.upload-widget__backdrop{opacity:0;-moz-transition:0.15s opacity linear;transition:0.15s opacity linear}.upload-widget__modal.show,.upload-widget__backdrop.show{opacity:1}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/UploadWidgetContainer.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget{--btn-text-color: var(--shade-200);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-moz-box-sizing:border-box;box-sizing:border-box;color:var(--shade-100);font-family:var(--base-font-family);font-size:var(--base-font-size);line-height:1;text-align:left;position:static}.upload-widget__root{position:absolute;left:0;right:0;top:0;bottom:0}.upload-widget a,.upload-widget p,.upload-widget button{font-size:inherit;margin:0}.upload-widget a{border-bottom:none;padding:0}.upload-widget svg{margin-bottom:0}.upload-widget__controls{text-align:center;padding:.9375em}.upload-widget__controls--space button:not(:last-child){margin-right:0.5em}.upload-widget a{color:var(--primary-color)}.upload-widget a,.upload-widget a:hover,.upload-widget a:active,.upload-widget a:focus{-webkit-text-decoration:underline;text-decoration:underline}.upload-widget a:hover:not(:disabled):not(.disabled){color:var(--primary-active-color)}.upload-widget .btn{-moz-transition:0.1s border-color linear, 0.1s background-color linear;transition:0.1s border-color linear, 0.1s background-color linear;display:inline-block;font-weight:400;color:var(--btn-text-color);text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:rgba(0,0,0,0);border:.0625em solid rgba(0,0,0,0);padding:0 1em;line-height:3;border-radius:0.3125em}.upload-widget .btn,.upload-widget .btn:hover,.upload-widget .btn:active,.upload-widget .btn:focus{-webkit-text-decoration:none;text-decoration:none}.upload-widget .btn:not(:disabled):not(.disabled){cursor:pointer}.upload-widget .btn:hover:not(:disabled):not(.disabled){color:var(--shade-300)}.upload-widget .btn--primary{color:var(--shade-900);background-color:var(--primary-color);border-color:var(--primary-color)}.upload-widget .btn--primary:hover:not(:disabled):not(.disabled){background-color:var(--primary-active-color);border-color:var(--primary-active-color);color:var(--shade-900)}.upload-widget .btn--primary-outline{color:var(--primary-color);border-color:var(--primary-color)}.upload-widget .btn.disabled{opacity:0.5;cursor:default}.upload-widget .btn--file{position:relative;overflow:hidden;margin-bottom:0}.upload-widget .btn--file__input{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;z-index:-1}.upload-widget .btn--upload{font-size:1.11em;padding:0.2em 1.6em;margin-bottom:1.5em}.upload-widget .text-secondary{color:var(--shade-400)}.upload-widget .vcenter{display:-webkit-flex;display:-moz-box;display:flex;-webkit-align-items:center;-moz-box-align:center;align-items:center}.upload-widget .hcenter{display:-webkit-flex;display:-moz-box;display:flex;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center}.upload-widget .nudge-up-1{position:relative;top:-1px}.upload-widget .ml-0{margin-left:0}.upload-widget .ml-1{margin-left:.3125em}.upload-widget .ml-2{margin-left:.4375em}.upload-widget .ml-3{margin-left:.5em}.upload-widget .ml-4{margin-left:.625em}.upload-widget .mr-0{margin-right:0}.upload-widget .mr-1{margin-right:.3125em}.upload-widget .mr-2{margin-right:.4375em}.upload-widget .mr-3{margin-right:.5em}.upload-widget .mr-4{margin-right:.625em}.upload-widget .mb-0{margin-bottom:0}.upload-widget .mb-1{margin-bottom:.3125em}.upload-widget .mb-2{margin-bottom:.4375em}.upload-widget .mb-3{margin-bottom:.5em}.upload-widget .mb-4{margin-bottom:.625em}.upload-widget .mt-0{margin-top:0}.upload-widget .mt-1{margin-top:.3125em}.upload-widget .mt-2{margin-top:.4375em}.upload-widget .mt-3{margin-top:.5em}.upload-widget .mt-4{margin-top:.625em}.upload-widget .mt-5{margin-top:1.25em}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageCropper.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__image-cropper__overlay{position:absolute;background:rgba(255,255,255,0.5)}.upload-widget__image-cropper__clip{overflow:hidden}.upload-widget__image-cropper__clip img{max-width:none;max-width:initial}.upload-widget__image-cropper__clip:before{content:\" \";display:block;background:rgba(255,255,255,0.15);position:absolute;left:-2px;right:-2px;top:-2px;bottom:-2px}.upload-widget__image-cropper__clip--circular,.upload-widget__image-cropper__clip--circular:before{border-radius:100%}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageEditorLayout.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__image-editor{display:-webkit-flex;display:-moz-box;display:flex;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;-webkit-align-content:space-between;align-content:space-between;height:100%;width:100%}.upload-widget__image-editor img{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}.upload-widget__image-editor__header{padding:0.825em 0.8em 0.75em 0.8em}.upload-widget__image-editor__header--empty-non-modal{min-height:.9375em}.upload-widget__image-editor__image{width:100%;-webkit-flex-grow:1;-moz-box-flex:1;flex-grow:1;position:relative}.upload-widget__image-editor__image-padding{position:absolute;top:0;bottom:0;left:.9375em;right:.9375em;display:-webkit-flex;display:-moz-box;display:flex;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center}.upload-widget__image-editor__image-inner{max-width:100%;max-height:100%}.upload-widget__modal .upload-widget__image-editor__header{padding-top:0;padding-bottom:1.3em;margin-top:-1em}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/Spinner.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@-webkit-keyframes spinner{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes spinner{to{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner{to{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);transform:rotate(360deg)}}.spinner{display:block !important;border:0.275em solid var(--shade-700);border-right-color:transparent;border-radius:50%;-webkit-animation:spinner 0.75s linear infinite;-moz-animation:spinner 0.75s linear infinite;animation:spinner 0.75s linear infinite}.spinner__container{display:-webkit-flex;display:-moz-box;display:flex;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;height:100%;width:100%}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/shapes/ResizableSquare.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__resizable-square{position:absolute;cursor:move}.upload-widget__resizable-square__nw,.upload-widget__resizable-square__ne,.upload-widget__resizable-square__sw,.upload-widget__resizable-square__se{width:1em;height:1em;opacity:0.75;background-color:var(--shade-900);border:.0625em solid var(--primary-color);border-radius:100%;position:absolute;display:block !important}.upload-widget__resizable-square__nw{top:-.5em;left:-.5em;cursor:nw-resize}.upload-widget__resizable-square__ne{top:-.5em;right:-.5em;cursor:ne-resize}.upload-widget__resizable-square__sw{bottom:-.5em;left:-.5em;cursor:sw-resize}.upload-widget__resizable-square__se{bottom:-.5em;right:-.5em;cursor:se-resize}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/fileIcons/ProgressIcon.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-icon{display:block}.progress-icon__container{display:inline-block;position:relative}.progress-icon__circle{-moz-transition:.35s stroke-dashoffset cubic-bezier(0.33, 1, 0.68, 1), .6s stroke-width cubic-bezier(0.22, 1, 0.36, 1), .6s r cubic-bezier(0.22, 1, 0.36, 1), .3s opacity linear;transition:.35s stroke-dashoffset cubic-bezier(0.33, 1, 0.68, 1), .6s stroke-width cubic-bezier(0.22, 1, 0.36, 1), .6s r cubic-bezier(0.22, 1, 0.36, 1), .3s opacity linear;-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg);-ms-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:50% 50%;-moz-transform-origin:50% 50%;-ms-transform-origin:50% 50%;transform-origin:50% 50%;stroke:var(--primary-color)}.progress-icon__circle__bg{-moz-transition:.3s opacity linear;transition:.3s opacity linear;fill:var(--shade-700)}.progress-icon__circle--error{stroke:var(--error-color)}.progress-icon__thumbnail{-moz-transition:.2s transform cubic-bezier(0.22, 1, 0.36, 1), .05s opacity linear;transition:.2s transform cubic-bezier(0.22, 1, 0.36, 1), .05s opacity linear;-moz-transition-delay:.3s;transition-delay:.3s;background-repeat:no-repeat;background-position:center center;background-size:contain;opacity:1;position:absolute;left:0;right:0;top:0;bottom:0;-webkit-transform:scale(1, 1);-moz-transform:scale(1, 1);-ms-transform:scale(1, 1);transform:scale(1, 1)}.progress-icon__thumbnail--hidden{opacity:0;-webkit-transform:scale(0.1, 0.1);-moz-transform:scale(0.1, 0.1);-ms-transform:scale(0.1, 0.1);transform:scale(0.1, 0.1)}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/files/SubmittedFileComponent.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__internal--md .upload-widget__submitted-file{max-width:100%;width:100%}.upload-widget__internal--lg .upload-widget__submitted-file{max-width:50%;width:50%}.upload-widget__internal--xl .upload-widget__submitted-file{max-width:33.333333%;width:33.333333%}.upload-widget__internal--xl .upload-widget__submitted-file--loners{max-width:46%;width:46%}.upload-widget__submitted-file{-webkit-flex-grow:1;-moz-box-flex:1;flex-grow:1;margin:.3125em 0}.upload-widget__submitted-file__container{margin:0 .3125em;background:var(--shade-800);border-radius:.4375em}.upload-widget__submitted-file__inner{padding:1.3125em 1.4375em;display:-webkit-flex;display:-moz-box;display:flex;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-justify-content:space-between;-moz-box-pack:justify;justify-content:space-between}.upload-widget__submitted-file__text{margin-left:.4375em;margin-right:.5em;overflow:hidden;-webkit-flex-grow:1;-moz-box-flex:1;flex-grow:1}.upload-widget__submitted-file__action{min-width:4.625em;text-align:right;display:inline-block}.upload-widget__submitted-file__action--performed{color:var(--shade-300)}.upload-widget__submitted-file__message{font-size:0.75em;margin-top:0.2em;display:block;line-height:1.1em}.upload-widget__submitted-file__name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;height:1.1em}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/internal/UploadWidgetInternal.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__internal{border-radius:.3125em;position:absolute;top:.9375em;left:.9375em;right:.9375em;bottom:.9375em;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;display:-webkit-flex;display:-moz-box;display:flex}.upload-widget__internal__modal-bg{color:var(--shade-600);position:absolute;z-index:1}.upload-widget__internal__modal-bg--dragging{color:var(--primary-color)}.upload-widget__internal__modal-bg--dragging *{pointer-events:none}.upload-widget__internal__children{-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;display:-webkit-flex;display:-moz-box;display:flex;z-index:2;position:absolute;bottom:0;top:0;left:0;right:0}.upload-widget__internal__children--is-modal{top:2.5em}.upload-widget__internal--draggable{border:.125em dashed var(--shade-600)}.upload-widget__internal--dragging{border-color:var(--primary-color)}.upload-widget__internal--dragging *{pointer-events:none}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/screens/UploaderMainScreen.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-widget__main-screen{display:-webkit-flex;display:-moz-box;display:flex;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center;-webkit-align-items:center;-moz-box-align:center;align-items:center;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;-webkit-align-content:space-between;align-content:space-between;height:100%;width:100%}.upload-widget__main-screen__file-list{margin:auto 0;overflow-y:auto;width:100%}.upload-widget__main-screen__file-list__inner{padding:.9375em;display:-webkit-flex;display:-moz-box;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center}.upload-widget__main-screen__info{color:var(--btn-text-color);text-align:center;padding:1.15em 0}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/***/ (function(module) {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	!function() {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  UploadWidget: function() { return /* reexport */ UploadWidget_UploadWidget; },
  UploadWidgetLocaleEnUs: function() { return /* reexport */ UploadWidgetLocaleEnUs; },
  UploadWidgetResult: function() { return /* reexport */ UploadWidgetResult; },
  UploadWidgetValidationError: function() { return /* reexport */ UploadWidgetValidationError; }
});

;// CONCATENATED MODULE: external "preact/jsx-runtime"
var jsx_runtime_namespaceObject = require("preact/jsx-runtime");
;// CONCATENATED MODULE: ./src/modules/locales/EN_US.ts
var UploadWidgetLocaleEnUs = {
  addAnotherFileBtn: "Add another file...",
  addAnotherImageBtn: "Add another image...",
  cancelBtn: "cancel",
  cancelBtnClicked: "cancelled",
  cancelPreviewBtn: "Cancel",
  continueBtn: "Continue",
  cropBtn: "Crop",
  customValidationFailed: "Failed to validate file.",
  doneBtn: "Done",
  fileSizeLimitPrefix: "File size limit:",
  finishBtn: "Finished",
  finishBtnIcon: true,
  imageCropNumberPrefix: "Image",
  maxFilesReachedPrefix: "Maximum number of files:",
  maxImagesReachedPrefix: "Maximum number of images:",
  orDragDropFile: "...or drag and drop a file.",
  orDragDropFileMulti: "...or drag and drop files.",
  orDragDropImage: "...or drag and drop an image.",
  orDragDropImageMulti: "...or drag and drop images.",
  processingFile: "Processing file...",
  removeBtn: "remove",
  removeBtnClicked: "removed",
  submitBtnError: "Error!",
  submitBtnLoading: "Please wait...",
  unsupportedFileType: "File type not supported.",
  uploadFileBtn: "Upload a File",
  uploadFileMultiBtn: "Upload a File",
  uploadImageBtn: "Upload an Image",
  uploadImageMultiBtn: "Upload an Image",
  xOfY: "of"
};
;// CONCATENATED MODULE: ./src/config/UploadWidgetEditor.ts
var UploadWidgetEditorRequired;
(function (UploadWidgetEditorRequired) {
  function from(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var cropShape = (_b = (_a = options === null || options === void 0 ? void 0 : options.images) === null || _a === void 0 ? void 0 : _a.cropShape) !== null && _b !== void 0 ? _b : "rect";
    var crop = (_d = (_c = options === null || options === void 0 ? void 0 : options.images) === null || _c === void 0 ? void 0 : _c.crop) !== null && _d !== void 0 ? _d : true;
    return {
      images: {
        allowResizeOnMove: (_f = (_e = options === null || options === void 0 ? void 0 : options.images) === null || _e === void 0 ? void 0 : _e.allowResizeOnMove) !== null && _f !== void 0 ? _f : true,
        crop: crop,
        cropFilePath: (_h = (_g = options === null || options === void 0 ? void 0 : options.images) === null || _g === void 0 ? void 0 : _g.cropFilePath) !== null && _h !== void 0 ? _h : function (originalImage) {
          return "".concat(originalImage.filePath, ".crop");
        },
        cropRatio: cropShape === "circ" ? 1 : (_j = options === null || options === void 0 ? void 0 : options.images) === null || _j === void 0 ? void 0 : _j.cropRatio,
        cropShape: cropShape,
        // Prevents introducing a new step for existing users where previously they didn't expect any interruption, but
        // shows previews for new file types (PDFs) to users who are already expecting interruption for image uploads.
        // "If at least one editor option is enabled, then previews are enabled by default".
        preview: (_l = (_k = options === null || options === void 0 ? void 0 : options.images) === null || _k === void 0 ? void 0 : _k.preview) !== null && _l !== void 0 ? _l : crop
      }
    };
  }
  UploadWidgetEditorRequired.from = from;
})(UploadWidgetEditorRequired || (UploadWidgetEditorRequired = {}));
;// CONCATENATED MODULE: ./src/modules/ColorUtils.ts
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// Original: https://stackoverflow.com/a/54070620/592768
// License: https://creativecommons.org/licenses/by-sa/4.0/legalcode
function rgb2hsv(r, g, b) {
  var v = Math.max(r, g, b);
  var c = v - Math.min(r, g, b);
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  var h = c && (v === r ? (g - b) / c : v === g ? 2 + (b - r) / c : 4 + (r - g) / c);
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return [60 * (h < 0 ? h + 6 : h), v && c / v, v];
}
// Original: https://stackoverflow.com/a/54024653/592768
// License: https://creativecommons.org/licenses/by-sa/4.0/legalcode
function hsv2rgb(h, s, v) {
  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 60) % 6;
    return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  };
  return [f(5), f(3), f(1)];
}
// Original: https://stackoverflow.com/a/5624139/592768
// License: https://creativecommons.org/licenses/by-sa/4.0/legalcode
function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (_, r, g, b) {
    return "".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result === null) {
    throw new Error("Invalid color code: ".concat(hex));
  }
  return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)];
}
function highlightColor(hex, amount) {
  var _hexToRgb = hexToRgb(hex),
    _hexToRgb2 = _slicedToArray(_hexToRgb, 3),
    r = _hexToRgb2[0],
    g = _hexToRgb2[1],
    b = _hexToRgb2[2];
  var _rgb2hsv = rgb2hsv(r, g, b),
    _rgb2hsv2 = _slicedToArray(_rgb2hsv, 3),
    h = _rgb2hsv2[0],
    s = _rgb2hsv2[1],
    v = _rgb2hsv2[2];
  var clipToFactor = function clipToFactor(x) {
    return Math.min(1, Math.max(0, x));
  };
  var _hsv2rgb$map = hsv2rgb(h, clipToFactor(s + amount * -1), clipToFactor(v / 255 + amount) * 255).map(Math.round),
    _hsv2rgb$map2 = _slicedToArray(_hsv2rgb$map, 3),
    rNew = _hsv2rgb$map2[0],
    gNew = _hsv2rgb$map2[1],
    bNew = _hsv2rgb$map2[2];
  return "rgb(".concat(rNew, ", ").concat(gNew, ", ").concat(bNew, ")");
}
;// CONCATENATED MODULE: ./src/config/UploadWidgetColors.ts

var UploaderColorOptionsRequired;
(function (UploaderColorOptionsRequired) {
  function from(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var primaryDefault = "#377dff";
    var activeDefault = "#528fff";
    var primary = (_a = options === null || options === void 0 ? void 0 : options.primary) !== null && _a !== void 0 ? _a : primaryDefault;
    var active;
    try {
      active = highlightColor(primary, 0.1);
    } catch (e) {
      console.error("Invalid hex code '".concat(primary, "', using default colours."));
      primary = primaryDefault;
      active = activeDefault;
    }
    return {
      primary: primary,
      active: (_b = options === null || options === void 0 ? void 0 : options.active) !== null && _b !== void 0 ? _b : active,
      error: (_c = options === null || options === void 0 ? void 0 : options.error) !== null && _c !== void 0 ? _c : "#d23f4d",
      shade100: (_d = options === null || options === void 0 ? void 0 : options.shade100) !== null && _d !== void 0 ? _d : "#333",
      shade200: (_e = options === null || options === void 0 ? void 0 : options.shade200) !== null && _e !== void 0 ? _e : "#7a7a7a",
      shade300: (_f = options === null || options === void 0 ? void 0 : options.shade300) !== null && _f !== void 0 ? _f : "#999",
      shade400: (_g = options === null || options === void 0 ? void 0 : options.shade400) !== null && _g !== void 0 ? _g : "#a5a6a8",
      shade500: (_h = options === null || options === void 0 ? void 0 : options.shade500) !== null && _h !== void 0 ? _h : "#d3d3d3",
      shade600: (_j = options === null || options === void 0 ? void 0 : options.shade600) !== null && _j !== void 0 ? _j : "#dddddd",
      shade700: (_k = options === null || options === void 0 ? void 0 : options.shade700) !== null && _k !== void 0 ? _k : "#f0f0f0",
      shade800: (_l = options === null || options === void 0 ? void 0 : options.shade800) !== null && _l !== void 0 ? _l : "#f8f8f8",
      shade900: (_m = options === null || options === void 0 ? void 0 : options.shade900) !== null && _m !== void 0 ? _m : "#fff" // 900 DONE
    };
  }
  UploaderColorOptionsRequired.from = from;
})(UploaderColorOptionsRequired || (UploaderColorOptionsRequired = {}));
;// CONCATENATED MODULE: ./src/config/UploadWidgetFontSize.ts
var UploadWidgetFontSizeRequired;
(function (UploadWidgetFontSizeRequired) {
  function from(options) {
    var _a;
    return {
      base: (_a = options === null || options === void 0 ? void 0 : options.base) !== null && _a !== void 0 ? _a : 16
    };
  }
  UploadWidgetFontSizeRequired.from = from;
})(UploadWidgetFontSizeRequired || (UploadWidgetFontSizeRequired = {}));
;// CONCATENATED MODULE: ./src/config/UploadWidgetFontFamily.ts
var UploadWidgetFontFamilyRequired;
(function (UploadWidgetFontFamilyRequired) {
  function from(options) {
    var _a;
    return {
      base: (_a = options === null || options === void 0 ? void 0 : options.base) !== null && _a !== void 0 ? _a : "-apple-system, blinkmacsystemfont, Segoe UI, helvetica, arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol"
    };
  }
  UploadWidgetFontFamilyRequired.from = from;
})(UploadWidgetFontFamilyRequired || (UploadWidgetFontFamilyRequired = {}));
;// CONCATENATED MODULE: ./src/config/UploadWidgetBreakpoints.ts
var UploadWidgetBreakpointsRequired;
(function (UploadWidgetBreakpointsRequired) {
  function from(options) {
    var _a, _b;
    return {
      fullScreenWidth: (_a = options === null || options === void 0 ? void 0 : options.fullScreenWidth) !== null && _a !== void 0 ? _a : 750,
      fullScreenHeight: (_b = options === null || options === void 0 ? void 0 : options.fullScreenHeight) !== null && _b !== void 0 ? _b : 420
    };
  }
  UploadWidgetBreakpointsRequired.from = from;
})(UploadWidgetBreakpointsRequired || (UploadWidgetBreakpointsRequired = {}));
;// CONCATENATED MODULE: ./src/config/UploadWidgetStyles.ts




var UploadWidgetStylesRequired;
(function (UploadWidgetStylesRequired) {
  function from(options) {
    return {
      breakpoints: UploadWidgetBreakpointsRequired.from(options === null || options === void 0 ? void 0 : options.breakpoints),
      colors: UploaderColorOptionsRequired.from(options === null || options === void 0 ? void 0 : options.colors),
      fontFamilies: UploadWidgetFontFamilyRequired.from(options === null || options === void 0 ? void 0 : options.fontFamilies),
      fontSizes: UploadWidgetFontSizeRequired.from(options === null || options === void 0 ? void 0 : options.fontSizes)
    };
  }
  UploadWidgetStylesRequired.from = from;
})(UploadWidgetStylesRequired || (UploadWidgetStylesRequired = {}));
;// CONCATENATED MODULE: ./src/modules/locales/UploadWidgetLocaleDeprecatedFields.ts
var UploadWidgetLocaleDeprecatedFields;
(function (UploadWidgetLocaleDeprecatedFields) {
  function migrate(_ref) {
    var addAnotherFileBtn = _ref["addAnotherFile"],
      addAnotherImageBtn = _ref["addAnotherImage"],
      cancelBtn = _ref["cancel"],
      cancelPreviewBtn = _ref["cancelInPreviewWindow"],
      cancelBtnClicked = _ref["cancelled!"],
      continueBtn = _ref["continue"],
      cropBtn = _ref["crop"],
      doneBtn = _ref["done"],
      submitBtnError = _ref["error!"],
      finishBtn = _ref["finish"],
      finishBtnIcon = _ref["finishIcon"],
      imageCropNumberPrefix = _ref["image"],
      maxFilesReachedPrefix = _ref["maxFilesReached"],
      maxImagesReachedPrefix = _ref["maxImagesReached"],
      fileSizeLimitPrefix = _ref["maxSize"],
      xOfY = _ref["of"],
      orDragDropFileMulti = _ref["orDragDropFiles"],
      orDragDropImageMulti = _ref["orDragDropImages"],
      submitBtnLoading = _ref["pleaseWait"],
      removeBtn = _ref["remove"],
      removeBtnClicked = _ref["removed!"],
      uploadFileBtn = _ref["uploadFile"],
      uploadFileMultiBtn = _ref["uploadFiles"],
      uploadImageBtn = _ref["uploadImage"],
      uploadImageMultiBtn = _ref["uploadImages"];
    return {
      addAnotherFileBtn: addAnotherFileBtn,
      addAnotherImageBtn: addAnotherImageBtn,
      cancelBtn: cancelBtn,
      cancelBtnClicked: cancelBtnClicked,
      cancelPreviewBtn: cancelPreviewBtn,
      continueBtn: continueBtn,
      cropBtn: cropBtn,
      doneBtn: doneBtn,
      fileSizeLimitPrefix: fileSizeLimitPrefix,
      finishBtn: finishBtn,
      finishBtnIcon: finishBtnIcon,
      imageCropNumberPrefix: imageCropNumberPrefix,
      maxFilesReachedPrefix: maxFilesReachedPrefix,
      maxImagesReachedPrefix: maxImagesReachedPrefix,
      orDragDropFileMulti: orDragDropFileMulti,
      orDragDropImageMulti: orDragDropImageMulti,
      removeBtn: removeBtn,
      removeBtnClicked: removeBtnClicked,
      submitBtnError: submitBtnError,
      submitBtnLoading: submitBtnLoading,
      uploadFileBtn: uploadFileBtn,
      uploadFileMultiBtn: uploadFileMultiBtn,
      uploadImageBtn: uploadImageBtn,
      uploadImageMultiBtn: uploadImageMultiBtn,
      xOfY: xOfY
    };
  }
  UploadWidgetLocaleDeprecatedFields.migrate = migrate;
})(UploadWidgetLocaleDeprecatedFields || (UploadWidgetLocaleDeprecatedFields = {}));
;// CONCATENATED MODULE: ./src/modules/common/ObjectUtils.ts
function ObjectUtils_slicedToArray(arr, i) { return ObjectUtils_arrayWithHoles(arr) || ObjectUtils_iterableToArrayLimit(arr, i) || ObjectUtils_unsupportedIterableToArray(arr, i) || ObjectUtils_nonIterableRest(); }
function ObjectUtils_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ObjectUtils_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ObjectUtils_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ObjectUtils_arrayLikeToArray(o, minLen); }
function ObjectUtils_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ObjectUtils_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ObjectUtils_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function removeUndefinedAndNullFields(value) {
  return Object.fromEntries(Object.entries(value).filter(function (_ref) {
    var _ref2 = ObjectUtils_slicedToArray(_ref, 2),
      value = _ref2[1];
    return (value !== null && value !== void 0 ? value : undefined) !== undefined;
  }));
}
;// CONCATENATED MODULE: ./src/config/UploadWidgetConfig.ts





function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var UploadWidgetConfigRequired;
(function (UploadWidgetConfigRequired) {
  function from(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var layout = (_a = options.layout) !== null && _a !== void 0 ? _a : "modal";
    var multi = (_b = options.multi) !== null && _b !== void 0 ? _b : options.maxFileCount !== undefined && options.maxFileCount > 1;
    return {
      // Bytescale SDK settings:
      apiKey: options.apiKey,
      apiUrl: options.apiUrl,
      cdnUrl: options.cdnUrl,
      headers: options.headers,
      // Bytescale Upload Widget settings:
      container: options.container,
      editor: UploadWidgetEditorRequired.from(options.editor),
      layout: layout,
      locale: Object.assign(Object.assign({}, UploadWidgetLocaleEnUs), removeUndefinedAndNullFields(Object.assign(Object.assign({}, UploadWidgetLocaleDeprecatedFields.migrate((_c = options.locale) !== null && _c !== void 0 ? _c : {})), options.locale))),
      maxFileCount: options.maxFileCount,
      maxFileSizeBytes: options.maxFileSizeBytes,
      metadata: options.metadata,
      mimeTypes: (_d = options.mimeTypes) === null || _d === void 0 ? void 0 : _d.map(function (x) {
        return x.trim().toLowerCase();
      }),
      multi: multi,
      onInit: (_e = options.onInit) !== null && _e !== void 0 ? _e : function () {},
      onUpdate: (_f = options.onUpdate) !== null && _f !== void 0 ? _f : function () {},
      onPreUpload: _async(function (file) {
        var onPreUpload = options.onPreUpload;
        return onPreUpload === undefined ? undefined : onPreUpload(file);
      }),
      path: options.path,
      showFinishButton: (_g = options.showFinishButton) !== null && _g !== void 0 ? _g : multi ? layout === "modal" : false,
      showRemoveButton: (_h = options.showRemoveButton) !== null && _h !== void 0 ? _h : true,
      styles: UploadWidgetStylesRequired.from(options.styles),
      tags: (_j = options.tags) !== null && _j !== void 0 ? _j : []
    };
  }
  UploadWidgetConfigRequired.from = from;
})(UploadWidgetConfigRequired || (UploadWidgetConfigRequired = {}));
;// CONCATENATED MODULE: external "preact"
var external_preact_namespaceObject = require("preact");
// EXTERNAL MODULE: ./node_modules/@bytescale/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("./node_modules/@bytescale/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/@bytescale/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__("./node_modules/@bytescale/style-loader/dist/runtime/styleDomAPI.js");
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/@bytescale/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__("./node_modules/@bytescale/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/@bytescale/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__("./node_modules/@bytescale/style-loader/dist/runtime/insertStyleElement.js");
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/@bytescale/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__("./node_modules/@bytescale/style-loader/dist/runtime/styleTagTransform.js");
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/UploadWidgetContainer.scss
var UploadWidgetContainer = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/UploadWidgetContainer.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/UploadWidgetContainer.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());
options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(UploadWidgetContainer["default"], options);




       /* harmony default export */ var uploadWidget_UploadWidgetContainer = (UploadWidgetContainer["default"] && UploadWidgetContainer["default"].locals ? UploadWidgetContainer["default"].locals : undefined);

;// CONCATENATED MODULE: external "classnames"
var external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/internal/UploadWidgetInternal.scss
var UploadWidgetInternal = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/internal/UploadWidgetInternal.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/internal/UploadWidgetInternal.scss

      
      
      
      
      
      
      
      
      

var UploadWidgetInternal_options = {};

UploadWidgetInternal_options.styleTagTransform = (styleTagTransform_default());
UploadWidgetInternal_options.setAttributes = (setAttributesWithoutAttributes_default());
UploadWidgetInternal_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
UploadWidgetInternal_options.domAPI = (styleDomAPI_default());
UploadWidgetInternal_options.insertStyleElement = (insertStyleElement_default());

var UploadWidgetInternal_update = injectStylesIntoStyleTag_default()(UploadWidgetInternal["default"], UploadWidgetInternal_options);




       /* harmony default export */ var internal_UploadWidgetInternal = (UploadWidgetInternal["default"] && UploadWidgetInternal["default"].locals ? UploadWidgetInternal["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/assets/svgs/DashedBackgroundSvg.tsx

var baseWidth = 600;
var baseHeight = 400;
var baseNotchSize = 50;
var DashedBackgroundSvg = function DashedBackgroundSvg(_ref) {
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    notchSize = _ref.notchSize;
  var widthDelta = baseWidth - width;
  var heightDelta = baseHeight - height;
  var notchDelta = baseNotchSize - notchSize;
  return (0,jsx_runtime_namespaceObject.jsxs)("svg", Object.assign({
    width: width,
    height: height,
    className: className,
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [(0,jsx_runtime_namespaceObject.jsxs)("defs", {
      children: [(0,jsx_runtime_namespaceObject.jsx)("path", {
        d: "M76 99h".concat(536 - (widthDelta - notchDelta), "a7 7 0 0 1 7 7v").concat(36 - notchDelta, "a7 7 0 0 0 7 7h").concat(36 - notchDelta, "a7 7 0 0 1 7 7v").concat(336 - (heightDelta - notchDelta), "a7 7 0 0 1-7 7H76a7 7 0 0 1-7-7V106a7 7 0 0 1 7-7Z"),
        id: "rectWithNotch"
      }), (0,jsx_runtime_namespaceObject.jsx)("mask", Object.assign({
        id: "rectWithNotchMask",
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        x: "0",
        y: "0",
        width: width,
        height: height,
        fill: "#fff"
      }, {
        children: (0,jsx_runtime_namespaceObject.jsx)("use", {
          xlinkHref: "#rectWithNotch"
        })
      }))]
    }), (0,jsx_runtime_namespaceObject.jsx)("use", {
      mask: "url(#rectWithNotchMask)",
      xlinkHref: "#rectWithNotch",
      transform: "translate(-69 -99)",
      stroke: "currentColor",
      strokeWidth: "4",
      fill: "none",
      fillRule: "evenodd",
      strokeDasharray: "4"
    })]
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/internal/border/UploadWidgetInternalBorder.tsx



var UploadWidgetInternalBorder = function UploadWidgetInternalBorder(_ref) {
  var closeButtonSize = _ref.closeButtonSize,
    isDragging = _ref.isDragging,
    dimensions = _ref.dimensions;
  if (dimensions === undefined) {
    return (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {});
  }
  return (0,jsx_runtime_namespaceObject.jsx)(DashedBackgroundSvg, {
    width: dimensions.width,
    height: dimensions.height,
    notchSize: closeButtonSize,
    className: external_classnames_default()("upload-widget__internal__modal-bg", {
      "upload-widget__internal__modal-bg--dragging": isDragging
    })
  });
};
;// CONCATENATED MODULE: external "preact/compat"
var compat_namespaceObject = require("preact/compat");
;// CONCATENATED MODULE: ./src/assets/svgs/utils/ResizedSvg.tsx
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * IE11 doesn't like it when setting only width or height, so this utility makes it easier to set both.
 */
var ResizedSvg = function ResizedSvg(_a) {
  var children = _a.children,
    className = _a.className,
    originalHeight = _a.originalHeight,
    originalWidth = _a.originalWidth,
    style = _a.style,
    rest = __rest(_a, ["children", "className", "originalHeight", "originalWidth", "style"]);
  var widthMaybe = rest === null || rest === void 0 ? void 0 : rest.width;
  var heightMaybe = rest === null || rest === void 0 ? void 0 : rest.height;
  return (0,jsx_runtime_namespaceObject.jsx)("svg", Object.assign({
    viewBox: "0 0 ".concat(originalWidth, " ").concat(originalHeight),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    style: Object.assign(Object.assign({}, style), heightMaybe !== undefined ? {
      height: "".concat(heightMaybe, "px"),
      width: "".concat(heightMaybe * (originalWidth / originalHeight), "px")
    } : widthMaybe !== undefined ? {
      width: "".concat(widthMaybe, "px"),
      height: "".concat(widthMaybe * (originalHeight / originalWidth), "px")
    } : {})
  }, {
    children: children
  }));
};
;// CONCATENATED MODULE: ./src/assets/svgs/CloseSvg.tsx


var CloseSvg = function CloseSvg(_ref) {
  var className = _ref.className,
    width = _ref.width;
  return (0,jsx_runtime_namespaceObject.jsx)(ResizedSvg, Object.assign({
    originalWidth: 27,
    originalHeight: 26,
    width: width !== null && width !== void 0 ? width : 27,
    className: className
  }, {
    children: (0,jsx_runtime_namespaceObject.jsxs)("g", Object.assign({
      transform: "rotate(45 6.547 16.13)",
      fill: "currentColor",
      fillRule: "evenodd"
    }, {
      children: [(0,jsx_runtime_namespaceObject.jsx)("rect", {
        x: "7.75",
        width: "2.5",
        height: "18",
        rx: "1.25"
      }), (0,jsx_runtime_namespaceObject.jsx)("rect", {
        transform: "rotate(90 9 9)",
        x: "7.75",
        width: "2.5",
        height: "18",
        rx: "1.25"
      })]
    }))
  }));
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/modal/Modal.scss
var Modal = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/modal/Modal.scss");
;// CONCATENATED MODULE: ./src/components/modal/Modal.scss

      
      
      
      
      
      
      
      
      

var Modal_options = {};

Modal_options.styleTagTransform = (styleTagTransform_default());
Modal_options.setAttributes = (setAttributesWithoutAttributes_default());
Modal_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
Modal_options.domAPI = (styleDomAPI_default());
Modal_options.insertStyleElement = (insertStyleElement_default());

var Modal_update = injectStylesIntoStyleTag_default()(Modal["default"], Modal_options);




       /* harmony default export */ var modal_Modal = (Modal["default"] && Modal["default"].locals ? Modal["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/modal/Modal.tsx
function Modal_slicedToArray(arr, i) { return Modal_arrayWithHoles(arr) || Modal_iterableToArrayLimit(arr, i) || Modal_unsupportedIterableToArray(arr, i) || Modal_nonIterableRest(); }
function Modal_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function Modal_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Modal_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Modal_arrayLikeToArray(o, minLen); }
function Modal_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Modal_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function Modal_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var modalTransitionDuration = 250; // Actual CSS transition of 'fade' is 150ms, but we add 100ms for safety.
var modalCloseButtonSize = 27;
var modalCloseButtonPadding = 11;
var Modal_Modal = function Modal(_ref) {
  var children = _ref.children,
    closeModal = _ref.closeModal;
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = Modal_slicedToArray(_useState, 2),
    isClosed = _useState2[0],
    setIsClosed = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(false),
    _useState4 = Modal_slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = (0,compat_namespaceObject.useState)(false),
    _useState6 = Modal_slicedToArray(_useState5, 2),
    showModalAsync = _useState6[0],
    setShowModalAsync = _useState6[1];
  var showModal = visible && !isClosed;
  var doClose = function doClose() {
    setIsClosed(true);
  };
  (0,compat_namespaceObject.useEffect)(function () {
    if (!visible) {
      setVisible(true);
    }
  }, [visible]);
  (0,compat_namespaceObject.useEffect)(function () {
    if (!isClosed) {
      return;
    }
    var timeout = setTimeout(function () {
      closeModal();
    }, modalTransitionDuration);
    return function () {
      return clearTimeout(timeout);
    };
  }, [isClosed]);
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    var oldHtmlClass = document.documentElement.className;
    var oldBodyClass = document.body.className;
    document.documentElement.className = "".concat(oldHtmlClass, " upload-widget__html");
    document.body.className = "".concat(oldBodyClass, " upload-widget__body");
    return function () {
      document.documentElement.className = oldHtmlClass;
      document.body.className = oldBodyClass;
    };
  }, []);
  (0,compat_namespaceObject.useEffect)(function () {
    if (showModal && !showModalAsync) {
      var f = window.requestAnimationFrame(function () {
        setShowModalAsync(true);
      });
      return function () {
        return window.cancelAnimationFrame(f);
      };
    } else if (showModalAsync) {
      setShowModalAsync(false);
    }
  }, [showModal]);
  // 'onMouseDown' vs 'onClick':
  // When cropping an image, if we start a crop then release the mouse button outside the modal, it appears to register
  // as an 'onClick', so we use 'onMouseDown' to fix this.
  return (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [showModal && (0,jsx_runtime_namespaceObject.jsx)("div", {
      className: external_classnames_default()("upload-widget__backdrop", {
        show: showModalAsync
      }),
      onMouseDown: doClose
    }), showModal && (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
      className: external_classnames_default()("upload-widget__modal", {
        show: showModalAsync
      })
    }, {
      children: [children, (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
        className: "upload-widget__modal__close"
      }, {
        children: (0,jsx_runtime_namespaceObject.jsx)("a", Object.assign({
          href: "#close",
          onClick: function onClick(e) {
            e.preventDefault();
            doClose();
          }
        }, {
          children: (0,jsx_runtime_namespaceObject.jsx)(CloseSvg, {
            width: modalCloseButtonSize
          })
        }))
      }))]
    }))]
  });
};
;// CONCATENATED MODULE: ./src/modules/common/UseDimensionsFromElement.ts
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || UseDimensionsFromElement_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return UseDimensionsFromElement_arrayLikeToArray(arr); }
function UseDimensionsFromElement_slicedToArray(arr, i) { return UseDimensionsFromElement_arrayWithHoles(arr) || UseDimensionsFromElement_iterableToArrayLimit(arr, i) || UseDimensionsFromElement_unsupportedIterableToArray(arr, i) || UseDimensionsFromElement_nonIterableRest(); }
function UseDimensionsFromElement_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseDimensionsFromElement_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UseDimensionsFromElement_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UseDimensionsFromElement_arrayLikeToArray(o, minLen); }
function UseDimensionsFromElement_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UseDimensionsFromElement_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UseDimensionsFromElement_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useElementRef() {
  var _useState = (0,compat_namespaceObject.useState)(undefined),
    _useState2 = UseDimensionsFromElement_slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var elementRef = (0,compat_namespaceObject.useCallback)(function (e) {
    setElement(e !== null && e !== void 0 ? e : undefined);
  }, []);
  return [element, elementRef];
}
function getElementDimensionsOnResize(isElementReady, imageSizeDeps) {
  var _useElementRef = useElementRef(),
    _useElementRef2 = UseDimensionsFromElement_slicedToArray(_useElementRef, 2),
    element = _useElementRef2[0],
    elementRef = _useElementRef2[1];
  var dimensions = doGetElementDimensionsOnResize(isElementReady, element, element, imageSizeDeps);
  return [dimensions, elementRef];
}
function getElementDimensionsOnParentResize(isElementReady, imageSizeDeps) {
  var _useElementRef3 = useElementRef(),
    _useElementRef4 = UseDimensionsFromElement_slicedToArray(_useElementRef3, 2),
    element = _useElementRef4[0],
    elementRef = _useElementRef4[1];
  var _useElementRef5 = useElementRef(),
    _useElementRef6 = UseDimensionsFromElement_slicedToArray(_useElementRef5, 2),
    parentElement = _useElementRef6[0],
    parentElementRef = _useElementRef6[1];
  var dimensions = doGetElementDimensionsOnResize(isElementReady, element, parentElement, imageSizeDeps);
  return [dimensions, elementRef, parentElementRef];
}
function doGetElementDimensionsOnResize(isElementReady, element, parentElement, imageSizeDeps) {
  // Must be 'undefined' to begin with, as these dimensions will be zero'd if the element isn't ready (i.e. it's an image and hasn't loaded yet).
  // IMPORTANT: do not override 'onload' for an image to achieve this, as we're already setting the attribute elsewhere, so don't want to overwrite the handler.
  var _useState3 = (0,compat_namespaceObject.useState)(undefined),
    _useState4 = UseDimensionsFromElement_slicedToArray(_useState3, 2),
    dimensions = _useState4[0],
    setDimensions = _useState4[1];
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    var updateDimensions = function updateDimensions() {
      if (isElementReady) {
        setDimensions(getDimensionsFromElement(element));
      }
    };
    if (element === undefined || parentElement === undefined) {
      return;
    }
    var observer = new ResizeObserver(updateDimensions);
    observer.observe(parentElement);
    return function () {
      return observer.disconnect();
    };
  }, [element, isElementReady].concat(_toConsumableArray(imageSizeDeps)));
  return dimensions;
}
function getDimensionsFromElement(element) {
  if (element === undefined) {
    return undefined;
  }
  var domRect = element.getBoundingClientRect();
  return {
    width: domRect.width,
    height: domRect.height,
    x: element.offsetLeft,
    y: element.offsetTop
  };
}
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/internal/UploadWidgetInternal.tsx
function UploadWidgetInternal_slicedToArray(arr, i) { return UploadWidgetInternal_arrayWithHoles(arr) || UploadWidgetInternal_iterableToArrayLimit(arr, i) || UploadWidgetInternal_unsupportedIterableToArray(arr, i) || UploadWidgetInternal_nonIterableRest(); }
function UploadWidgetInternal_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadWidgetInternal_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UploadWidgetInternal_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UploadWidgetInternal_arrayLikeToArray(o, minLen); }
function UploadWidgetInternal_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UploadWidgetInternal_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UploadWidgetInternal_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var UploadWidgetInternal_UploadWidgetInternal = function UploadWidgetInternal(_ref) {
  var children = _ref.children,
    htmlProps = _ref.htmlProps,
    isDraggable = _ref.isDraggable,
    isDragging = _ref.isDragging,
    layout = _ref.layout;
  var _a, _b;
  var _getElementDimensions = getElementDimensionsOnResize(true, []),
    _getElementDimensions2 = UploadWidgetInternal_slicedToArray(_getElementDimensions, 2),
    dimensions = _getElementDimensions2[0],
    containerRef = _getElementDimensions2[1];
  // Size is relative to the internal dimensions of the upload widget, as opposed to the screen. This caters for the
  // widget entering "full screen" mode when being shrunk, which causes the internal dimensions of the widget to become
  // larger. Hence, we measure these breakpoints based off the internal widget size, rather than the screen size.
  var internalBreakpoints = [{
    width: 650,
    value: "md"
  }, {
    width: 930,
    value: "lg"
  }];
  var lastBreakpoint = "xl";
  var breakpoint = (_b = dimensions === undefined ? undefined : (_a = internalBreakpoints.find(function (x) {
    return dimensions.width <= x.width;
  })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : lastBreakpoint;
  return (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
    ref: containerRef,
    className: external_classnames_default()("upload-widget__internal", "upload-widget__internal--".concat(breakpoint), {
      "upload-widget__internal--draggable": isDraggable === true && layout !== "modal",
      "upload-widget__internal--dragging": isDragging === true && layout !== "modal"
    })
  }, htmlProps, {
    children: [isDraggable === true && layout === "modal" && (0,jsx_runtime_namespaceObject.jsx)(UploadWidgetInternalBorder, {
      isDragging: isDragging === true,
      dimensions: dimensions,
      closeButtonSize: modalCloseButtonSize + modalCloseButtonPadding
    }), (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      className: external_classnames_default()("upload-widget__internal__children", {
        "upload-widget__internal__children--is-modal": layout === "modal"
      })
    }, {
      children: children
    }))]
  }));
};
;// CONCATENATED MODULE: ./src/assets/svgs/RightSvg.tsx


var RightSvg = function RightSvg(_ref) {
  var className = _ref.className,
    width = _ref.width;
  return (0,jsx_runtime_namespaceObject.jsx)(ResizedSvg, Object.assign({
    originalWidth: 13,
    originalHeight: 10,
    width: width !== null && width !== void 0 ? width : 13,
    className: className
  }, {
    children: (0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M6.293.293a.999.999 0 0 0 0 1.414L8.586 4H1a1 1 0 0 0 0 2h7.586L6.293 8.293a.999.999 0 1 0 1.414 1.414L12.414 5 7.707.293a.999.999 0 0 0-1.414 0Z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/configError/ConfigError.tsx



var ConfigError = function ConfigError(_ref) {
  var error = _ref.error,
    layout = _ref.layout;
  var _a;
  var errorMessage = ((_a = error.message) !== null && _a !== void 0 ? _a : "unknown error").replace("[upload-js] ", "");
  var isApiKeyError = errorMessage.toLowerCase().includes("api key");
  return (0,jsx_runtime_namespaceObject.jsxs)(UploadWidgetInternal_UploadWidgetInternal, Object.assign({
    layout: layout,
    multi: false
  }, {
    children: [(0,jsx_runtime_namespaceObject.jsx)("h1", {
      children: isApiKeyError ? "Almost there..." : "Oops!"
    }), (0,jsx_runtime_namespaceObject.jsx)("p", {
      children: errorMessage
    }), isApiKeyError ? (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
      className: "mt-5"
    }, {
      children: [(0,jsx_runtime_namespaceObject.jsxs)("a", Object.assign({
        href: "https://www.bytescale.com/get-started",
        className: "btn btn--primary-outline"
      }, {
        children: ["Get API Key ", (0,jsx_runtime_namespaceObject.jsx)(RightSvg, {
          width: 12,
          className: "ml-2"
        })]
      })), " "]
    })) : (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {})]
  }));
};
;// CONCATENATED MODULE: ./src/modules/common/TypeUtils.ts
function isDefined(object) {
  return object !== undefined;
}
function assertUnreachable(_x) {
  throw new Error("Didn't expect to get here: ".concat(JSON.stringify(_x)));
}
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/UploadButton.tsx
function UploadButton_slicedToArray(arr, i) { return UploadButton_arrayWithHoles(arr) || UploadButton_iterableToArrayLimit(arr, i) || UploadButton_unsupportedIterableToArray(arr, i) || UploadButton_nonIterableRest(); }
function UploadButton_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadButton_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UploadButton_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UploadButton_arrayLikeToArray(o, minLen); }
function UploadButton_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UploadButton_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UploadButton_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var UploadButton = function UploadButton(_ref) {
  var className = _ref.className,
    options = _ref.options,
    onUpload = _ref.onUpload,
    text = _ref.text;
  var _a;
  var _useState = (0,compat_namespaceObject.useState)(Math.random()),
    _useState2 = UploadButton_slicedToArray(_useState, 1),
    fileInputKey = _useState2[0];
  var _useState3 = (0,compat_namespaceObject.useState)("upload-widget__input-".concat(Math.round(Math.random() * 1000000))),
    _useState4 = UploadButton_slicedToArray(_useState3, 1),
    inputId = _useState4[0];
  return (0,jsx_runtime_namespaceObject.jsxs)("label", Object.assign({
    className: external_classnames_default()("btn btn--file", className),
    htmlFor: inputId
  }, {
    children: [text, (0,jsx_runtime_namespaceObject.jsx)("input", Object.assign({
      id: inputId,
      name: inputId,
      accept: (_a = options.mimeTypes) === null || _a === void 0 ? void 0 : _a.join(","),
      type: "file",
      className: "btn--file__input"
    }, options.multi ? {
      multiple: true
    } : {}, {
      onChange: function onChange(e) {
        var _a, _b;
        var input = e.target;
        var files = Array.from((_b = (_a = input.files) !== null && _a !== void 0 ? _a : undefined) !== null && _b !== void 0 ? _b : []);
        if (files.length > 0) {
          onUpload(files);
        }
      }
    }), fileInputKey)]
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/UploaderWelcomeScreen.tsx


var UploaderWelcomeScreen = function UploaderWelcomeScreen(_ref) {
  var addFiles = _ref.addFiles,
    options = _ref.options,
    isImageUploader = _ref.isImageUploader;
  var multi = options.multi,
    locale = options.locale;
  return (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [(0,jsx_runtime_namespaceObject.jsx)(UploadButton, {
      options: options,
      text: isImageUploader ? multi ? locale.uploadImageMultiBtn : locale.uploadImageBtn : multi ? locale.uploadFileMultiBtn : locale.uploadFileBtn,
      className: "btn--primary btn--upload",
      onUpload: addFiles
    }), (0,jsx_runtime_namespaceObject.jsx)("p", Object.assign({
      className: "text-secondary mb-0"
    }, {
      children: isImageUploader ? multi ? locale.orDragDropImageMulti : locale.orDragDropImage : multi ? locale.orDragDropFileMulti : locale.orDragDropFile
    }))]
  });
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/fileIcons/ProgressIcon.scss
var ProgressIcon = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/fileIcons/ProgressIcon.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/ProgressIcon.scss

      
      
      
      
      
      
      
      
      

var ProgressIcon_options = {};

ProgressIcon_options.styleTagTransform = (styleTagTransform_default());
ProgressIcon_options.setAttributes = (setAttributesWithoutAttributes_default());
ProgressIcon_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
ProgressIcon_options.domAPI = (styleDomAPI_default());
ProgressIcon_options.insertStyleElement = (insertStyleElement_default());

var ProgressIcon_update = injectStylesIntoStyleTag_default()(ProgressIcon["default"], ProgressIcon_options);




       /* harmony default export */ var fileIcons_ProgressIcon = (ProgressIcon["default"] && ProgressIcon["default"].locals ? ProgressIcon["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/ProgressIcon.tsx
function ProgressIcon_slicedToArray(arr, i) { return ProgressIcon_arrayWithHoles(arr) || ProgressIcon_iterableToArrayLimit(arr, i) || ProgressIcon_unsupportedIterableToArray(arr, i) || ProgressIcon_nonIterableRest(); }
function ProgressIcon_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ProgressIcon_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ProgressIcon_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProgressIcon_arrayLikeToArray(o, minLen); }
function ProgressIcon_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ProgressIcon_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ProgressIcon_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var progressWheelVanish = 300;
var progressWheelDelay = 350;
var ProgressIcon_ProgressIcon = function ProgressIcon(_ref) {
  var height = _ref.height,
    progress = _ref.progress,
    onCompleteImageSource = _ref.onCompleteImageSource,
    isError = _ref.isError;
  var _useState = (0,compat_namespaceObject.useState)(progress === 1),
    _useState2 = ProgressIcon_slicedToArray(_useState, 2),
    completed = _useState2[0],
    setCompleted = _useState2[1];
  var radius = height / 2;
  var stokeWidth = radius * 2;
  var size = stokeWidth * 2;
  var circumference = radius * 2 * Math.PI;
  var strokeDashoffset = circumference - progress * circumference;
  var strokeDasharray = "".concat(circumference, " ").concat(circumference);
  (0,compat_namespaceObject.useEffect)(function () {
    if (progress === 1 && !completed) {
      var timeout = setTimeout(function () {
        setCompleted(true);
      }, progressWheelDelay - 50); // We want to start this _just_ before the wheel finishes
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [progress]);
  return (0,jsx_runtime_namespaceObject.jsxs)("span", Object.assign({
    className: "progress-icon__container"
  }, {
    children: [(0,jsx_runtime_namespaceObject.jsxs)("svg", Object.assign({
      className: "progress-icon",
      width: size,
      height: size
    }, {
      children: [(0,jsx_runtime_namespaceObject.jsx)("circle", {
        className: "progress-icon__circle__bg",
        strokeWidth: 0,
        r: size / 2,
        cx: size / 2,
        cy: size / 2,
        style: {
          opacity: completed ? 0 : 1
        }
      }), (0,jsx_runtime_namespaceObject.jsx)("circle", {
        className: external_classnames_default()("progress-icon__circle", {
          "progress-icon__circle--error": isError
        }),
        strokeWidth: completed ? 0 : stokeWidth,
        fill: "transparent",
        r: completed ? 0 : radius,
        cx: stokeWidth,
        cy: stokeWidth,
        style: {
          strokeDasharray: strokeDasharray,
          strokeDashoffset: strokeDashoffset,
          opacity: completed ? 0 : 1
        }
      })]
    })), (0,jsx_runtime_namespaceObject.jsx)("span", {
      className: external_classnames_default()("progress-icon__thumbnail", {
        "progress-icon__thumbnail--hidden": !completed
      }),
      style: {
        backgroundImage: "url(".concat(onCompleteImageSource, ")")
      }
    })]
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Document.svg
/* harmony default export */ var Document = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjAgMjIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNjAgMjIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMTAwIDBIMTVDNyAwIDAgNyAwIDE1djE5MGMwIDggNyAxNSAxNSAxNWgxMzBjOCAwIDE1LTcgMTUtMTVWNjBsLTM1LTI1LTI1LTM1eiIgc3R5bGU9ImZpbGw6IzQyODVmNCIvPjxwYXRoIGQ9Ik00MCAxNjBoODB2LTEwSDQwdjEwem0wIDIwaDYwdi0xMEg0MHYxMHptMC03MHYxMGg4MHYtMTBINDB6bTAgMzBoODB2LTEwSDQwdjEweiIgc3R5bGU9ImZpbGw6I2YxZjFmMSIvPjxwYXRoIGQ9Ik0xMDAgMHY0NWMwIDggNyAxNSAxNSAxNWg0NUwxMDAgMHoiIHN0eWxlPSJmaWxsOiNhMWMyZmEiLz48L3N2Zz4K");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Spreadsheet.svg
/* harmony default export */ var Spreadsheet = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjAgMjEwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNjAgMjEwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNXoiIHN0eWxlPSJmaWxsOiM0M2EwNDciLz48cGF0aCBkPSJNMTYwIDUwaC01MFYwbDUwIDUweiIgc3R5bGU9ImZpbGw6I2M4ZTZjOSIvPjxwYXRoIGQ9Im0xMTAgNTAgNTAgNTBWNTBoLTUweiIgc3R5bGU9ImZpbGw6IzJlN2QzMiIvPjxwYXRoIGQ9Ik0xMTUgMTAwSDM1djcwaDkwdi03MGgtMTB6bS03MCAxMGgyMHYxMEg0NXYtMTB6bTAgMjBoMjB2MTBINDV2LTEwem0wIDIwaDIwdjEwSDQ1di0xMHptNzAgMTBINzV2LTEwaDQwdjEwem0wLTIwSDc1di0xMGg0MHYxMHptMC0yMEg3NXYtMTBoNDB2MTB6IiBzdHlsZT0iZmlsbDojZThmNWU5Ii8+PC9zdmc+Cg==");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Slideshow.svg
/* harmony default export */ var Slideshow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48ZmlsdGVyIGlkPSJhIj48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDEuMDAwMDAwIDAgMCAwIDAgMS4wMDAwMDAgMCAwIDAgMCAxLjAwMDAwMCAwIDAgMCAxLjAwMDAwMCAwIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNVoiIGZpbGw9IiNEMzUyMzAiLz48cGF0aCBmaWxsPSIjRkY4NDY0IiBkPSJNMTYwIDUwaC01MFYweiIvPjxwYXRoIGZpbGw9IiNCNDQyMjMiIGQ9Im0xMTAgNTAgNTAgNTBWNTB6Ii8+PC9nPjxnIGZpbHRlcj0idXJsKCNhKSI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTIxLjY1OSA5NEgzOC4zMzNDMzMuNzM3IDk0IDMwIDk3LjcyMyAzMCAxMDIuM3Y0NS42NWMwIDQuNTc3IDMuNzM3IDguMyA4LjMzMyA4LjNINzUuODN2OC4zYzAgMS45NTktMS42MTMgMy45NjctNC40MjUgNS41MjQtMy4yNDIgMS43ODgtNy41OTEgMi43NzYtMTIuMjM3IDIuNzc2VjE3N2g0MS42NjR2LTQuMTVjLTQuNjYzIDAtOS4wMTItLjk4NC0xMi4yMzctMi43NzYtMi44MTItMS41NTctNC40MjUtMy41NjUtNC40MjUtNS41MjR2LTguM2gzNy40OTdjNC41OTYgMCA4LjMzMy0zLjcyMyA4LjMzMy04LjNWMTAyLjNjMC00LjU3Ny0zLjczNy04LjMtOC4zMzMtOC4zaC0uMDA4Wm0tMzYuNDggNzguODVINzQuODE3YzMuMjQxLTIuMTkxIDUuMTgzLTUuMDg0IDUuMTgzLTguMyAwIDMuMjE2IDEuOTQyIDYuMTA5IDUuMTgzIDguM2gtLjAwNFpNMzguMzMzIDEwMi4zaDgzLjMyNnYzNy4zNUgzOC4zMzNWMTAyLjNjLS4wMTMgMCAwIDAgMCAwWm0wIDQ1LjY1di00LjE1aDgzLjMyNnY0LjE1SDM4LjMzM1oiLz48cGF0aCBkPSJNNjcuOTg2IDEzNi43Yy4zMzYuMi43MTMuMyAxLjA4NS4zLjMxMSAwIC42MzQtLjA3Ni45MzMtLjIxMmwyNC44NTctMTJBMS45OTMgMS45OTMgMCAwIDAgOTYgMTIzYzAtLjc1Mi0uNDQtMS40NTItMS4xNC0xLjc4OGwtMjQuODU2LTEyYTIuMTQ1IDIuMTQ1IDAgMCAwLTIuMDIyLjA4OEExLjk5MyAxLjk5MyAwIDAgMCA2NyAxMTF2MjRjMCAuNjg4LjM3NyAxLjMzNi45ODIgMS43aC4wMDRabTMuMTYxLTIyLjQ2NEw4OS4yOTcgMTIzbC0xOC4xNSA4Ljc2NFYxMTQuMjM2WiIvPjwvZz48L2c+PC9nPjwvc3ZnPgo=");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Archive.svg
/* harmony default export */ var Archive = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48ZmlsdGVyIGlkPSJhIj48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDEuMDAwMDAwIDAgMCAwIDAgMS4wMDAwMDAgMCAwIDAgMCAxLjAwMDAwMCAwIDAgMCAxLjAwMDAwMCAwIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNVoiIGZpbGw9IiM4NkFCRUIiLz48cGF0aCBmaWxsPSIjQzRENEYxIiBkPSJNMTYwIDUwaC01MFYweiIvPjxwYXRoIGZpbGw9IiM3MThGQzMiIGQ9Im0xMTAgNTAgNTAgNTBWNTB6Ii8+PC9nPjxnIGZpbHRlcj0idXJsKCNhKSI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMzkgOTEuNjkxaDE4LjMzOHY5LjE2OUgzOXpNNDguMTY5IDEwMC44NmgxOC4zMzh2OS4xNjlINDguMTY5eiIvPjxwYXRoIGQ9Ik00OC4xNjkgMTAwLjg2aDkuMTY5djE4LjMzOGgtOS4xNjl6TTM5IDczLjM1M2gxOC4zMzh2OS4xNjlIMzl6TTQ4LjE2OSA4Mi41MjJoMTguMzM4djkuMTY5SDQ4LjE2OXpNMzkgNTUuMDE1aDE4LjMzOHY5LjE2OUgzOXpNNDguMTY5IDY0LjE4NGgxOC4zMzh2OS4xNjlINDguMTY5ek0zOSAzNi42NzZoMTguMzM4djkuMTY5SDM5ek00OC4xNjkgNDUuODQ2aDE4LjMzOHY5LjE2OUg0OC4xNjl6TTM5IDE4LjMzOGgxOC4zMzh2OS4xNjlIMzl6TTQ4LjE2OSAyNy41MDdoMTguMzM4djkuMTY5SDQ4LjE2OXpNMzkgMGgxOC4zMzh2OS4xNjlIMzl6TTQ4LjE2OSA5LjE2OWgxOC4zMzh2OS4xNjlINDguMTY5eiIvPjxwYXRoIGQ9Ik01Mi43NTQgMTE3LjAzYzcuNTk2IDAgMTMuNzUzIDYuMTU3IDEzLjc1MyAxMy43NTN2MTMuNzU0YTkuMTcgOS4xNyAwIDAgMS05LjE2OSA5LjE2OUg0OC4xN2E5LjE3IDkuMTcgMCAwIDEtOS4xNjktOS4xN3YtMTMuNzUzYzAtNy41OTYgNi4xNTgtMTMuNzU0IDEzLjc1NC0xMy43NTRabTAgOS4xNjlhNC41ODUgNC41ODUgMCAwIDAtNC41ODUgNC41ODR2OS4xN2E0LjU4NSA0LjU4NSAwIDEgMCA5LjE3IDB2LTkuMTdhNC41ODUgNC41ODUgMCAwIDAtNC41ODUtNC41ODRaIi8+PC9nPjwvZz48L2c+PC9zdmc+Cg==");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Code.svg
/* harmony default export */ var Code = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Image.svg
/* harmony default export */ var svgs_Image = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48ZmlsdGVyIGlkPSJhIj48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDEuMDAwMDAwIDAgMCAwIDAgMS4wMDAwMDAgMCAwIDAgMCAxLjAwMDAwMCAwIDAgMCAxLjAwMDAwMCAwIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNVoiIGZpbGw9IiM0ZDhhZmEiLz48cGF0aCBmaWxsPSIjOTViNmZmIiBkPSJNMTYwIDUwaC01MFYweiIvPjxwYXRoIGZpbGw9IiMzZTcxZTQiIGQ9Im0xMTAgNTAgNTAgNTBWNTB6Ii8+PC9nPjxnIGZpbHRlcj0idXJsKCNhKSI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTI3IDE3MUgzM3YtMTguODU3bDI3LjExOC0zMy4wNDkgMzkuNzExIDMzLjA0OUwxMjcgMTQwLjI4OXpNMTMxIDExMC41YzAgOC4wMDktNi40OTEgMTQuNS0xNC41IDE0LjVzLTE0LjUtNi40OTEtMTQuNS0xNC41UzEwOC40OTEgOTYgMTE2LjUgOTZzMTQuNSA2LjQ5MSAxNC41IDE0LjVaIi8+PC9nPjwvZz48L2c+PC9zdmc+Cg==");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Video.svg
/* harmony default export */ var Video = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48ZmlsdGVyIGlkPSJhIj48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDEuMDAwMDAwIDAgMCAwIDAgMS4wMDAwMDAgMCAwIDAgMCAxLjAwMDAwMCAwIDAgMCAxLjAwMDAwMCAwIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNVoiIGZpbGw9IiM4QzUwRTciLz48cGF0aCBmaWxsPSIjQjM4MEZGIiBkPSJNMTYwIDUwaC01MFYweiIvPjxwYXRoIGZpbGw9IiM3QzNGRDgiIGQ9Im0xMTAgNTAgNTAgNTBWNTB6Ii8+PC9nPjxnIGZpbHRlcj0idXJsKCNhKSI+PHBhdGggZD0iTTEyNi45NTggMTA0SDMzLjA0MkEyLjA0MiAyLjA0MiAwIDAgMCAzMSAxMDYuMDMxdjYwLjkzOGMwIDEuMTE3LjkxOSAyLjAzMSAyLjA0MiAyLjAzMWg5My45MTZhMi4wNDIgMi4wNDIgMCAwIDAgMi4wNDItMi4wMzFWMTA2LjAzYTIuMDQyIDIuMDQyIDAgMCAwLTIuMDQyLTIuMDMxWm0tNzkuNjI1IDQuMDYzdjguMTI0aC04LjE2NnYtOC4xMjRoOC4xNjZabS04LjE2NiAzNi41NjJoOC4xNjZ2OC4xMjVoLTguMTY2di04LjEyNVptMC00LjA2M3YtOC4xMjVoOC4xNjZ2OC4xMjVoLTguMTY2Wm0wLTEyLjE4N3YtOC4xMjVoOC4xNjZ2OC4xMjVoLTguMTY2Wm0wIDM2LjU2M3YtOC4xMjVoOC4xNjZ2OC4xMjVoLTguMTY2Wm02NS4zMzMtNC4wNjNoLTQ5di00OC43NWg0OXY0OC43NVptMTYuMzMzLTguMTI1aC04LjE2NnYtOC4xMjVoOC4xNjZ2OC4xMjVabTAtMTIuMTg4aC04LjE2NnYtOC4xMjVoOC4xNjZ2OC4xMjVabTAtMTIuMTg3aC04LjE2NnYtOC4xMjVoOC4xNjZ2OC4xMjVabS04LjE2NiAzNi41NjN2LTguMTI1aDguMTY2djguMTI1aC04LjE2NlptOC4xNjYtNDguNzVoLTguMTY2di04LjEyNmg4LjE2NnY4LjEyNloiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvZz48L2c+PC9zdmc+Cg==");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Audio.svg
/* harmony default export */ var Audio = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48ZmlsdGVyIGlkPSJhIj48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDEuMDAwMDAwIDAgMCAwIDAgMS4wMDAwMDAgMCAwIDAgMCAxLjAwMDAwMCAwIDAgMCAxLjAwMDAwMCAwIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTQ1IDIxMEgxNWMtOC4zIDAtMTUtNi43LTE1LTE1VjE1QzAgNi43IDYuNyAwIDE1IDBoOTVsNTAgNTB2MTQ1YzAgOC4zLTYuNyAxNS0xNSAxNVoiIGZpbGw9IiMwNzkxRkYiLz48cGF0aCBmaWxsPSIjQjNEREZGIiBkPSJNMTYwIDUwaC01MFYweiIvPjxwYXRoIGZpbGw9IiMwQTdDRDkiIGQ9Im0xMTAgNTAgNTAgNTBWNTB6Ii8+PC9nPjxnIGZpbHRlcj0idXJsKCNhKSI+PHBhdGggZD0iTTg5LjQwNSA5NS4wMWM5LjQ4IDIuMDQ1IDE3LjI4MSA2LjkwNCAyMy40MDcgMTQuNTc4IDYuMTI1IDcuNjc0IDkuMTg4IDE2LjQ4IDkuMTg4IDI2LjQxNyAwIDkuOTM3LTMuMDYzIDE4Ljc0My05LjE4OCAyNi40MTYtNi4xMjYgNy42NzQtMTMuOTI4IDEyLjUzNC0yMy40MDcgMTQuNTc5di05LjY0OWM2Ljg1NC0yLjA0NSAxMi40MzEtNS45MTggMTYuNzM0LTExLjYxOCA0LjMwMi01LjcgNi40NTQtMTIuMjc4IDYuNDU0LTE5LjczM3MtMi4xNTItMTQuMDMzLTYuNDU0LTE5LjczM2MtNC4zMDMtNS43LTkuODgtOS41NzMtMTYuNzM0LTExLjYxOFY5NXYuMDFabTExLjU5MiA0MWMwIDguNzctMy44NjQgMTUuMDU1LTExLjU5MiAxOC44NTN2LTM3LjcxMmMzLjIwOCAxLjYwOSA1Ljk0MiA0LjI0IDguMjA0IDcuODk1IDIuMjYxIDMuNjU1IDMuMzkyIDcuMzA5IDMuMzkyIDEwLjk2M2gtLjAwNFpNMzggMTIxLjk3N2gxOC41OTFsMjMuNDA3LTIzLjQ2djc0Ljk3OWwtMjMuNDA3LTIzLjQ2SDM4di0yOC4wNjQuMDA1WiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvZz48L3N2Zz4K");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Unknown.svg
/* harmony default export */ var Unknown = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik0xNDUgMjEwSDE1Yy04LjMgMC0xNS02LjctMTUtMTVWMTVDMCA2LjcgNi43IDAgMTUgMGg5NWw1MCA1MHYxNDVjMCA4LjMtNi43IDE1LTE1IDE1WiIgZmlsbD0iI2M5ZGNmZCIvPjxwYXRoIGZpbGw9IiNFQ0YzRkYiIGQ9Ik0xNjAgNTBoLTUwVjB6Ii8+PHBhdGggZmlsbD0iI2JjZDRmZSIgZD0ibTExMCA1MCA1MCA1MFY1MHoiLz48L2c+PC9zdmc+Cg==");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/utils/FileIconUtil.tsx









function getFileIconImageSource(fileName, mime) {
  var _a;
  var fn = fileName.toLowerCase().trim();
  var result = fileExtensionIcons.find(function (x) {
    return x.extensions.some(function (ext) {
      return fn.endsWith(ext);
    }) || x.mime.some(function (m) {
      return mime.startsWith(m);
    });
  });
  return (_a = result === null || result === void 0 ? void 0 : result.icon) !== null && _a !== void 0 ? _a : Unknown;
}
var fileExtensionIcons = [{
  icon: Document,
  extensions: [".docx", ".doc", ".txt", ".md", ".markdown", ".mkdown", ".mkdn", ".pdf"],
  mime: ["application/x-abiword", "application/msword", "application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
}, {
  icon: Spreadsheet,
  extensions: [".xlsx", ".xls", ".csv", ".tsv", ".psv"],
  mime: ["application/ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
}, {
  icon: Slideshow,
  extensions: [".pptx", ".ppt"],
  mime: ["application/vnd.apple.keynote", "application/ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"]
}, {
  icon: Archive,
  extensions: [".zip", ".tar", ".tar.gz", ".rar"],
  mime: []
}, {
  icon: svgs_Image,
  extensions: [],
  mime: ["image/"]
}, {
  icon: Video,
  extensions: [],
  mime: ["video/"]
}, {
  icon: Audio,
  extensions: [],
  mime: ["audio/"]
}, {
  icon: Code,
  extensions: [".json", ".js", ".ts", ".htm", ".html", ".css", ".sass"],
  mime: []
}];
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/files/SubmittedFileComponent.scss
var SubmittedFileComponent = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/files/SubmittedFileComponent.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/files/SubmittedFileComponent.scss

      
      
      
      
      
      
      
      
      

var SubmittedFileComponent_options = {};

SubmittedFileComponent_options.styleTagTransform = (styleTagTransform_default());
SubmittedFileComponent_options.setAttributes = (setAttributesWithoutAttributes_default());
SubmittedFileComponent_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
SubmittedFileComponent_options.domAPI = (styleDomAPI_default());
SubmittedFileComponent_options.insertStyleElement = (insertStyleElement_default());

var SubmittedFileComponent_update = injectStylesIntoStyleTag_default()(SubmittedFileComponent["default"], SubmittedFileComponent_options);




       /* harmony default export */ var files_SubmittedFileComponent = (SubmittedFileComponent["default"] && SubmittedFileComponent["default"].locals ? SubmittedFileComponent["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/fileIcons/svgs/Error.svg
/* harmony default export */ var svgs_Error = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNkMjNmNGQiIGN4PSIxNSIgY3k9IjE1IiByPSIxNSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNiA3LjYpIiBmaWxsPSIjRkZGIj48cmVjdCB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNy40MjUgNy40MjUpIiB4PSI1LjkyNSIgeT0iLTEuNTc1IiB3aWR0aD0iMyIgaGVpZ2h0PSIxOCIgcng9IjEuNSIvPjxyZWN0IHRyYW5zZm9ybT0icm90YXRlKDQ1IDcuNDI1IDcuNDI1KSIgeD0iNS45MjUiIHk9Ii0xLjU3NSIgd2lkdGg9IjMiIGhlaWdodD0iMTgiIHJ4PSIxLjUiLz48L2c+PC9nPjwvc3ZnPgo=");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/hypermedia/Hypermedia.tsx

var Link = function Link(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    text = _ref.text,
    url = _ref.url;
  return (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [prefix, " ", (0,jsx_runtime_namespaceObject.jsx)("a", Object.assign({
      href: url,
      target: "_blank",
      rel: "noopener"
    }, {
      children: text
    })), " ", suffix]
  });
};
function replaceFirstLink(text) {
  var matches = /^(.*?)(https?:\/\/[^\s)]+)(.*?)$/.exec(text);
  if (matches === null) {
    return undefined;
  }
  var prefix = matches[1];
  var url = matches[2];
  var suffix = matches[3];
  return (0,jsx_runtime_namespaceObject.jsx)(Link, {
    text: url,
    url: url,
    prefix: prefix,
    suffix: suffix
  });
}
function replaceUploadIo(text) {
  var find = "bytescale";
  var index = text.toLowerCase().indexOf(find);
  if (index === -1) {
    return undefined;
  }
  return (0,jsx_runtime_namespaceObject.jsx)(Link, {
    text: "Bytescale",
    url: "https://www.bytescale.com/pricing",
    prefix: text.substring(0, index),
    suffix: text.substring(index + find.length)
  });
}
var Hypermedia = function Hypermedia(_ref2) {
  var text = _ref2.text;
  var _a, _b;
  return (_b = (_a = replaceFirstLink(text)) !== null && _a !== void 0 ? _a : replaceUploadIo(text)) !== null && _b !== void 0 ? _b : (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
    children: text
  });
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/files/SubmittedFileComponent.tsx
function SubmittedFileComponent_slicedToArray(arr, i) { return SubmittedFileComponent_arrayWithHoles(arr) || SubmittedFileComponent_iterableToArrayLimit(arr, i) || SubmittedFileComponent_unsupportedIterableToArray(arr, i) || SubmittedFileComponent_nonIterableRest(); }
function SubmittedFileComponent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function SubmittedFileComponent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return SubmittedFileComponent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubmittedFileComponent_arrayLikeToArray(o, minLen); }
function SubmittedFileComponent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function SubmittedFileComponent_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function SubmittedFileComponent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










// Keep up-to-date with total animation duration in CSS.
var removalAnimationTime = 1000;
var SubmittedFileComponent_SubmittedFileComponent = function SubmittedFileComponent(_ref) {
  var file = _ref.file,
    fileCount = _ref.fileCount,
    remove = _ref.remove,
    locale = _ref.locale,
    showRemoveButton = _ref.showRemoveButton;
  var _a, _b;
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = SubmittedFileComponent_slicedToArray(_useState, 2),
    isDelayedRemove = _useState2[0],
    setIsDelayedRemove = _useState2[1];
  var delayedRemove = function delayedRemove() {
    setIsDelayedRemove(true);
  };
  (0,compat_namespaceObject.useEffect)(function () {
    if (!isDelayedRemove) {
      return;
    }
    var timeout = setTimeout(function () {
      remove();
    }, removalAnimationTime);
    return function () {
      return clearTimeout(timeout);
    };
  }, [isDelayedRemove]);
  var progressMargin = 0.03;
  var thumbnail = Unknown;
  var progress = 0;
  var fileName;
  var fileMessage;
  switch (file.type) {
    case "preprocessing":
      progress = 0;
      fileName = file.file.name;
      fileMessage = locale.processingFile;
      break;
    case "uploading":
      progress = Math.min(file.progress, 1 - progressMargin); // Do not let progress display 100%, as we don't have the MIME type & URL for the thumbnail yet. Plus it's confusing leaving it hanging on 100%.
      fileName = file.file.name;
      break;
    case "uploaded":
      progress = 1;
      thumbnail = getFileIconImageSource(file.uploadedFile.file.name, file.uploadedFile.mime);
      fileName = file.uploadedFile.file.name;
      break;
    case "failed":
      progress = 1;
      thumbnail = svgs_Error;
      fileMessage = (_b = (_a = file.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "Unexpected error occurred.";
      fileName = file.file.name;
      break;
    default:
      assertUnreachable(file);
  }
  return (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
    className: external_classnames_default()("upload-widget__submitted-file", {
      "upload-widget__submitted-file--loners": fileCount <= 2
    })
  }, {
    children: (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      className: "upload-widget__submitted-file__container"
    }, {
      children: (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
        className: "upload-widget__submitted-file__inner"
      }, {
        children: [(0,jsx_runtime_namespaceObject.jsx)(ProgressIcon_ProgressIcon, {
          progress: Math.max(progressMargin, progress),
          onCompleteImageSource: thumbnail,
          height: 15,
          isError: file.type === "failed"
        }), " ", (0,jsx_runtime_namespaceObject.jsxs)("span", Object.assign({
          className: "upload-widget__submitted-file__text"
        }, {
          children: [(0,jsx_runtime_namespaceObject.jsx)("span", Object.assign({
            className: "upload-widget__submitted-file__name",
            title: fileName
          }, {
            children: fileName
          })), fileMessage !== undefined && (0,jsx_runtime_namespaceObject.jsx)("span", Object.assign({
            className: "upload-widget__submitted-file__message"
          }, {
            children: (0,jsx_runtime_namespaceObject.jsx)(Hypermedia, {
              text: fileMessage
            })
          }))]
        })), isDelayedRemove ? (0,jsx_runtime_namespaceObject.jsx)("span", Object.assign({
          className: "upload-widget__submitted-file__action upload-widget__submitted-file__action--performed"
        }, {
          children: file.type === "uploading" ? locale.cancelBtnClicked : locale.removeBtnClicked
        })) : (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
          children: (showRemoveButton || file.type === "uploading") && (0,jsx_runtime_namespaceObject.jsx)("a", Object.assign({
            className: "upload-widget__submitted-file__action",
            href: "#remove",
            onClick: function onClick(e) {
              e.preventDefault();
              delayedRemove();
            }
          }, {
            children: file.type === "uploading" ? locale.cancelBtn : locale.removeBtn
          }))
        })]
      }))
    }))
  }));
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/screens/UploaderMainScreen.scss
var UploaderMainScreen = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/screens/UploaderMainScreen.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/UploaderMainScreen.scss

      
      
      
      
      
      
      
      
      

var UploaderMainScreen_options = {};

UploaderMainScreen_options.styleTagTransform = (styleTagTransform_default());
UploaderMainScreen_options.setAttributes = (setAttributesWithoutAttributes_default());
UploaderMainScreen_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
UploaderMainScreen_options.domAPI = (styleDomAPI_default());
UploaderMainScreen_options.insertStyleElement = (insertStyleElement_default());

var UploaderMainScreen_update = injectStylesIntoStyleTag_default()(UploaderMainScreen["default"], UploaderMainScreen_options);




       /* harmony default export */ var screens_UploaderMainScreen = (UploaderMainScreen["default"] && UploaderMainScreen["default"].locals ? UploaderMainScreen["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/UploaderMainScreen.tsx






var UploaderMainScreen_UploaderMainScreen = function UploaderMainScreen(_ref) {
  var addFiles = _ref.addFiles,
    submittedFiles = _ref.submittedFiles,
    uploadedFiles = _ref.uploadedFiles,
    options = _ref.options,
    _remove = _ref.remove,
    finalize = _ref.finalize,
    isImageUploader = _ref.isImageUploader;
  var finishedUploading = submittedFiles.every(function (x) {
    return x.type !== "uploading";
  });
  var canFinish = finishedUploading && uploadedFiles.length > 0;
  var locale = options.locale;
  var hasButtons = options.multi || options.showFinishButton;
  return (
    // Div required to break-out of flex-box layout.
    (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
      className: "upload-widget__main-screen"
    }, {
      children: [(0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
        className: "upload-widget__main-screen__file-list"
      }, {
        children: (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
          className: "upload-widget__main-screen__file-list__inner"
        }, {
          children: submittedFiles.map(function (file) {
            return (0,jsx_runtime_namespaceObject.jsx)(SubmittedFileComponent_SubmittedFileComponent, {
              file: file,
              fileCount: submittedFiles.length,
              locale: locale,
              remove: function remove() {
                return _remove(file.fileIndex);
              },
              showRemoveButton: options.showRemoveButton
            }, file.fileIndex);
          })
        }))
      })), hasButtons && (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
        className: "upload-widget__controls"
      }, {
        children: [options.multi && (options.maxFileCount === undefined || submittedFiles.length < options.maxFileCount ? (0,jsx_runtime_namespaceObject.jsx)(UploadButton, {
          options: options,
          text: isImageUploader ? locale.addAnotherImageBtn : locale.addAnotherFileBtn,
          onUpload: addFiles
        }) : (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
          className: "upload-widget__main-screen__info"
        }, {
          children: [isImageUploader ? locale.maxImagesReachedPrefix : locale.maxFilesReachedPrefix, " ", options.maxFileCount]
        }))), options.showFinishButton && (0,jsx_runtime_namespaceObject.jsx)("a", Object.assign({
          href: "#done",
          className: external_classnames_default()("btn btn--primary", {
            disabled: !canFinish
          }),
          onClick: function onClick(e) {
            e.preventDefault();
            if (canFinish) {
              finalize();
            }
          }
        }, {
          children: finishedUploading ? (0,jsx_runtime_namespaceObject.jsxs)("span", Object.assign({
            className: "vcenter hcenter"
          }, {
            children: [locale.finishBtn, " ", locale.finishBtnIcon && (0,jsx_runtime_namespaceObject.jsx)(RightSvg, {
              width: 12,
              className: "ml-2"
            })]
          })) : locale.submitBtnLoading
        }))]
      }))]
    }))
  );
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/model/SubmittedFile.ts
function isUploadedFile(file) {
  return file.type === "uploaded";
}
function isPendingFile(file) {
  return file.type === "preprocessing" || file.type === "uploading";
}
function isFailedFile(file) {
  return file.type === "failed";
}
;// CONCATENATED MODULE: ./src/modules/common/UseDragDrop.ts
function UseDragDrop_slicedToArray(arr, i) { return UseDragDrop_arrayWithHoles(arr) || UseDragDrop_iterableToArrayLimit(arr, i) || UseDragDrop_unsupportedIterableToArray(arr, i) || UseDragDrop_nonIterableRest(); }
function UseDragDrop_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseDragDrop_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UseDragDrop_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UseDragDrop_arrayLikeToArray(o, minLen); }
function UseDragDrop_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UseDragDrop_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UseDragDrop_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useDragDrop(acceptFiles) {
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = UseDragDrop_slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var handleDragEnter = function handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  var handleDragLeave = function handleDragLeave(e) {
    var _a;
    e.preventDefault();
    e.stopPropagation();
    if (e.relatedTarget !== null && ((_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) === true) {
      return;
    }
    setIsDragging(false);
  };
  var handleDragOver = function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer !== null) {
      e.dataTransfer.dropEffect = "copy";
    }
  };
  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer !== null) {
      var files = Array.from(e.dataTransfer.files);
      if (files.length > 0) {
        acceptFiles(files);
      }
    }
  };
  return {
    isDragging: isDragging,
    onDrop: function onDrop(e) {
      return handleDrop(e);
    },
    onDragOver: function onDragOver(e) {
      return handleDragOver(e);
    },
    onDragEnter: function onDragEnter(e) {
      return handleDragEnter(e);
    },
    onDragLeave: function onDragLeave(e) {
      return handleDragLeave(e);
    }
  };
}
;// CONCATENATED MODULE: ./src/modules/common/FormatUtils.ts
function humanFileSize(bytes) {
  var dp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var reference = bytes;
  var thresh = 1024;
  var sep = " ";
  var r = Math.pow(10, dp);
  var units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var magnitude = 0;
  if (Math.abs(reference) < thresh) {
    return "".concat(reference).concat(sep).concat(units[magnitude]);
  }
  do {
    bytes /= thresh;
    reference /= thresh;
    ++magnitude;
  } while (Math.round(Math.abs(reference) * r) / r >= thresh && magnitude < units.length - 1);
  var number = bytes.toFixed(dp);
  return number + sep + units[magnitude];
}
;// CONCATENATED MODULE: external "@bytescale/sdk"
var sdk_namespaceObject = require("@bytescale/sdk");
;// CONCATENATED MODULE: ./src/model/UploadWidgetResult.ts

var UploadWidgetResult;
(function (UploadWidgetResult) {
  function from(originalFile, editedFile) {
    var _a;
    var calculateFileUrl = function calculateFileUrl() {
      if (editedFile === undefined) {
        // Always return the original file if unedited (could be a ZIP, EXE, etc. so don't run through our image API).
        return sdk_namespaceObject.UrlBuilder.url({
          filePath: originalFile.filePath,
          accountId: originalFile.accountId
        });
      }
      // DO NOT add a width and height etc.
      // This causes confusion for users, as the expectation is this URL is the image they uploaded, not a resized version
      // of it, and has parity with the URL for images where the user has decided not to crop (which we simply return a
      // raw URL for).
      // The sole purpose of this result is to process CROP files so that they return as images, not JSON files, and to
      // do nothing more. (Again, for parity with uploading images where the user has decided not to crop.)
      return sdk_namespaceObject.UrlBuilder.url({
        filePath: editedFile.filePath,
        accountId: editedFile.accountId,
        options: {
          transformation: "image"
        }
      });
    };
    return {
      accountId: originalFile.accountId,
      etag: originalFile.etag,
      editedFile: editedFile,
      originalFile: originalFile,
      fileUrl: calculateFileUrl(),
      filePath: (_a = editedFile === null || editedFile === void 0 ? void 0 : editedFile.filePath) !== null && _a !== void 0 ? _a : originalFile.filePath
    };
  }
  UploadWidgetResult.from = from;
})(UploadWidgetResult || (UploadWidgetResult = {}));
;// CONCATENATED MODULE: ./src/modules/common/Rect.ts
var RectWithPos;
(function (RectWithPos) {
  function toCssProps(r) {
    return {
      width: r.width,
      height: r.height,
      left: r.x,
      top: r.y
    };
  }
  RectWithPos.toCssProps = toCssProps;
})(RectWithPos || (RectWithPos = {}));
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/shapes/ResizableSquare.scss
var ResizableSquare = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/shapes/ResizableSquare.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/shapes/ResizableSquare.scss

      
      
      
      
      
      
      
      
      

var ResizableSquare_options = {};

ResizableSquare_options.styleTagTransform = (styleTagTransform_default());
ResizableSquare_options.setAttributes = (setAttributesWithoutAttributes_default());
ResizableSquare_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
ResizableSquare_options.domAPI = (styleDomAPI_default());
ResizableSquare_options.insertStyleElement = (insertStyleElement_default());

var ResizableSquare_update = injectStylesIntoStyleTag_default()(ResizableSquare["default"], ResizableSquare_options);




       /* harmony default export */ var shapes_ResizableSquare = (ResizableSquare["default"] && ResizableSquare["default"].locals ? ResizableSquare["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/common/Draggable.tsx
function Draggable_slicedToArray(arr, i) { return Draggable_arrayWithHoles(arr) || Draggable_iterableToArrayLimit(arr, i) || Draggable_unsupportedIterableToArray(arr, i) || Draggable_nonIterableRest(); }
function Draggable_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function Draggable_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Draggable_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Draggable_arrayLikeToArray(o, minLen); }
function Draggable_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Draggable_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function Draggable_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var Draggable = function Draggable(_ref) {
  var boundary = _ref.boundary,
    children = _ref.children,
    className = _ref.className,
    onMoveCallback = _ref.onMove,
    style = _ref.style,
    startingValue = _ref.startingValue,
    deltaCacheKey = _ref.deltaCacheKey;
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = Draggable_slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(0),
    _useState4 = Draggable_slicedToArray(_useState3, 2),
    startX = _useState4[0],
    setStartX = _useState4[1];
  var _useState5 = (0,compat_namespaceObject.useState)(0),
    _useState6 = Draggable_slicedToArray(_useState5, 2),
    startY = _useState6[0],
    setStartY = _useState6[1];
  var _useState7 = (0,compat_namespaceObject.useState)(0),
    _useState8 = Draggable_slicedToArray(_useState7, 2),
    lastXDelta = _useState8[0],
    setLastXDelta = _useState8[1];
  var _useState9 = (0,compat_namespaceObject.useState)(0),
    _useState10 = Draggable_slicedToArray(_useState9, 2),
    lastYDelta = _useState10[0],
    setLastYDelta = _useState10[1];
  var _useState11 = (0,compat_namespaceObject.useState)(startingValue),
    _useState12 = Draggable_slicedToArray(_useState11, 2),
    start = _useState12[0],
    setStart = _useState12[1];
  var clip = function clip(min, max, value) {
    return Math.min(Math.max(value, min), max);
  };
  var clipDimension = function clipDimension(length, value) {
    return clip(length * -1, length, value);
  };
  var setPositionStart = function setPositionStart(e) {
    setStartX(e.pageX);
    setStartY(e.pageY);
  };
  var getPositionDelta = function getPositionDelta(e) {
    return {
      x: e.pageX - startX + lastXDelta,
      y: e.pageY - startY + lastYDelta
    };
  };
  var onDown = function onDown(e) {
    e.stopPropagation(); // Required so that if a draggable element exists within another draggable element, when the child element is dragged, the parent element is not.
    e.target.setPointerCapture(e.pointerId);
    setIsDragging(true);
    setPositionStart(e);
    if (deltaCacheKey === undefined || startingValue.lastUpdatedBy !== deltaCacheKey) {
      setLastXDelta(0);
      setLastYDelta(0);
      setStart(startingValue);
    }
  };
  var onUp = function onUp(e) {
    setIsDragging(false);
    e.target.releasePointerCapture(e.pointerId);
    var _getPositionDelta = getPositionDelta(e),
      x = _getPositionDelta.x,
      y = _getPositionDelta.y;
    setLastYDelta(clipDimension(boundary.height, y));
    setLastXDelta(clipDimension(boundary.width, x));
  };
  var onMove = function onMove(e) {
    if (!isDragging) {
      return;
    }
    var _getPositionDelta2 = getPositionDelta(e),
      x = _getPositionDelta2.x,
      y = _getPositionDelta2.y;
    onMoveCallback(x, y, start);
  };
  var onTouchStart = function onTouchStart(e) {
    // Cancel scrolling on mobile, which causes dragging to immediately halt after it's started.
    e.preventDefault();
  };
  return (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
    className: className,
    style: style,
    onPointerDown: onDown,
    onPointerMove: onMove,
    onPointerUp: onUp,
    onPointerCancel: onUp,
    onTouchStart: onTouchStart
  }, {
    children: children
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/shapes/ResizableSquare.tsx
function ResizableSquare_slicedToArray(arr, i) { return ResizableSquare_arrayWithHoles(arr) || ResizableSquare_iterableToArrayLimit(arr, i) || ResizableSquare_unsupportedIterableToArray(arr, i) || ResizableSquare_nonIterableRest(); }
function ResizableSquare_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ResizableSquare_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ResizableSquare_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ResizableSquare_arrayLikeToArray(o, minLen); }
function ResizableSquare_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ResizableSquare_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ResizableSquare_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function makeDeltaCacheKey(corner, allowResizeOnMove) {
  return allowResizeOnMove ? corner : undefined;
}
var CornerDragger = function CornerDragger(_ref) {
  var boundary = _ref.boundary,
    corner = _ref.corner,
    geometry = _ref.geometry,
    setGeometry = _ref.setGeometry;
  return (0,jsx_runtime_namespaceObject.jsx)(Draggable, {
    className: "upload-widget__resizable-square__".concat(corner),
    boundary: boundary,
    deltaCacheKey: undefined,
    startingValue: geometry,
    onMove: function onMove(x, y, g) {
      return setGeometry(corner, {
        x: corner === "nw" || corner === "sw" ? g.x + x : g.x,
        y: corner === "nw" || corner === "ne" ? g.y + y : g.y,
        width: corner === "nw" || corner === "sw" ? g.width - x : g.width + x,
        height: corner === "nw" || corner === "ne" ? g.height - y : g.height + y
      });
    }
  });
};
var ResizableSquare_ResizableSquare = function ResizableSquare(_ref2) {
  var boundary = _ref2.boundary,
    ratio = _ref2.ratio,
    onResized = _ref2.onResized,
    children = _ref2.children,
    allowResizeOnMove = _ref2.allowResizeOnMove;
  var minSize = 50;
  var adjustedBoundary = {
    width: boundary.width - minSize,
    height: boundary.height - minSize
  };
  var reRatio = function reRatio(g, fixed) {
    if (ratio === undefined) {
      return Object.assign(Object.assign({}, g), {
        lastUpdatedBy: fixed
      });
    }
    var width = Math.min(g.height * ratio, g.width);
    var height = width / ratio;
    return {
      lastUpdatedBy: fixed,
      height: height,
      width: width,
      x: fixed === "ne" || fixed === "se" ? g.x : fixed === "center" ? g.x + g.width / 2 - width / 2 : g.x + (g.width - width),
      y: fixed === "sw" || fixed === "se" ? g.y : fixed === "center" ? g.y + g.height / 2 - height / 2 : g.y + (g.height - height)
    };
  };
  var clip = function clip(g) {
    var x = Math.min(boundary.width - minSize, Math.max(0, g.x)); // x is clipped, but width may continue to grow. We should deduct from width the amount that's clipped?
    var y = Math.min(boundary.height - minSize, Math.max(0, g.y));
    var xClip = Math.min(0, g.x);
    var yClip = Math.min(0, g.y);
    return {
      x: x,
      y: y,
      width: Math.max(minSize, Math.min(g.width + xClip, boundary.width - x)),
      height: Math.max(minSize, Math.min(g.height + yClip, boundary.height - y))
    };
  };
  var clipAndReRatio = function clipAndReRatio(g, fixed) {
    return reRatio(clip(g), fixed);
  };
  var calculateInitialGeometry = function calculateInitialGeometry() {
    return clipAndReRatio({
      x: 0,
      y: 0,
      width: boundary.width,
      height: boundary.height
    }, "center");
  };
  var _useState = (0,compat_namespaceObject.useState)(calculateInitialGeometry),
    _useState2 = ResizableSquare_slicedToArray(_useState, 2),
    geometry = _useState2[0],
    setGeometryUnsafe = _useState2[1];
  var setGeometry = function setGeometry(corner, set) {
    return setGeometryUnsafe(clipAndReRatio(set, corner));
  };
  var onGeometryChange = function onGeometryChange() {
    var isSameAsBoundary = geometry.x === 0 && geometry.y === 0 && geometry.width === boundary.width && geometry.height === boundary.height;
    onResized(isSameAsBoundary ? undefined : {
      geometry: geometry,
      boundary: boundary
    });
  };
  (0,compat_namespaceObject.useLayoutEffect)(onGeometryChange, [geometry]);
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    setGeometryUnsafe(calculateInitialGeometry());
    onGeometryChange();
  }, [boundary]);
  return (0,jsx_runtime_namespaceObject.jsxs)(Draggable, Object.assign({
    className: "upload-widget__resizable-square",
    boundary: adjustedBoundary,
    style: RectWithPos.toCssProps(geometry),
    deltaCacheKey: makeDeltaCacheKey("center", allowResizeOnMove),
    startingValue: geometry,
    onMove: function onMove(x, y, g) {
      var clipperNoOp = function clipperNoOp(newValue) {
        return newValue;
      };
      var clipperRetainSize = function clipperRetainSize(newValue, size, bound) {
        var newValueClipped = Math.max(0, newValue);
        if (newValueClipped + size > bound) {
          return bound - size;
        }
        return newValueClipped;
      };
      var clipper = allowResizeOnMove ? clipperNoOp : clipperRetainSize;
      setGeometry("center", {
        x: clipper(g.x + x, g.width, boundary.width),
        y: clipper(g.y + y, g.height, boundary.height),
        width: g.width,
        height: g.height
      });
    }
  }, {
    children: [children, (0,jsx_runtime_namespaceObject.jsx)(CornerDragger, {
      corner: "nw",
      setGeometry: setGeometry,
      geometry: geometry,
      boundary: adjustedBoundary
    }), (0,jsx_runtime_namespaceObject.jsx)(CornerDragger, {
      corner: "ne",
      setGeometry: setGeometry,
      geometry: geometry,
      boundary: adjustedBoundary
    }), (0,jsx_runtime_namespaceObject.jsx)(CornerDragger, {
      corner: "se",
      setGeometry: setGeometry,
      geometry: geometry,
      boundary: adjustedBoundary
    }), (0,jsx_runtime_namespaceObject.jsx)(CornerDragger, {
      corner: "sw",
      setGeometry: setGeometry,
      geometry: geometry,
      boundary: adjustedBoundary
    })]
  }));
};
;// CONCATENATED MODULE: ./src/modules/MimeUtils.ts
var isEditableImage = function isEditableImage(originalImage) {
  return originalImage.mime.toLowerCase().startsWith("image/");
};
/**
 * Returns 'true' if the file can be rendered as an image (via our Image Processing API), but image editing options
 * should not be shown.
 *
 * IMPORTANT:
 * Must be mutually exclusive with 'isEditableImage' (there's several parts of the code that assume this).
 */
var isReadOnlyImage = function isReadOnlyImage(originalImage) {
  var mime = originalImage.mime.toLowerCase();
  return mime.startsWith("application/pdf") || mime.startsWith("video/");
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/modules/PreviewImageUrlCalculator.ts

// Do not allow SVGs, as these may include scripts, so a user may unwittingly upload an SVG that captures their own session information.
var nativelySupportedImages = ["image/jpeg", "image/gif", "image/png", "image/webp"];
function calculateImagePreviewUrl(originalImage) {
  if (isImageNativelySupported(originalImage)) {
    try {
      return {
        url: URL.createObjectURL(originalImage.file),
        external: false,
        urlForDimensions: undefined
      };
    } catch (e) {
      // This happens when 'onPreUpload' is used and a 'transformedFile' is returned; createObjectURL does not recognise
      // these, so we catch the error and fall-through to the Bytescale API-generated preview instead.
    }
  }
  // We use WebP to support transparency, e.g. in SVGs.
  // and use fit=max to enlarge SVGs (as they typically come out very small
  // if left in their native dimensions).
  var enlarge = requiresServeSideEnlargement(originalImage);
  var imageUrl = originalImage.fileUrl.replace("/raw/", "/image/");
  var maxDimension = 1000;
  return {
    url: "".concat(imageUrl, "?f=webp&f2=jpg").concat(enlarge ? "&w=".concat(maxDimension, "&h=").concat(maxDimension, "&fit=max") : ""),
    external: true,
    urlForDimensions: enlarge ? "".concat(imageUrl, "?f=jpg") : undefined
  };
}
function isImageNativelySupported(originalImage) {
  return nativelySupportedImages.includes(originalImage.mime);
}
/**
 * SVGs can come out very small natively, but can obviously be enlarged without affecting quality, so we enlarge them
 * server-side for the previews.
 * @param originalImage
 */
function requiresServeSideEnlargement(originalImage) {
  return isReadOnlyImage(originalImage) || originalImage.mime === "image/svg+xml";
}
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/Spinner.scss
var Spinner = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/Spinner.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/Spinner.scss

      
      
      
      
      
      
      
      
      

var Spinner_options = {};

Spinner_options.styleTagTransform = (styleTagTransform_default());
Spinner_options.setAttributes = (setAttributesWithoutAttributes_default());
Spinner_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
Spinner_options.domAPI = (styleDomAPI_default());
Spinner_options.insertStyleElement = (insertStyleElement_default());

var Spinner_update = injectStylesIntoStyleTag_default()(Spinner["default"], Spinner_options);




       /* harmony default export */ var editors_Spinner = (Spinner["default"] && Spinner["default"].locals ? Spinner["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/Spinner.tsx
function Spinner_slicedToArray(arr, i) { return Spinner_arrayWithHoles(arr) || Spinner_iterableToArrayLimit(arr, i) || Spinner_unsupportedIterableToArray(arr, i) || Spinner_nonIterableRest(); }
function Spinner_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function Spinner_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Spinner_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Spinner_arrayLikeToArray(o, minLen); }
function Spinner_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Spinner_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function Spinner_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var Spinner_Spinner = function Spinner() {
  var _a, _b;
  var _getElementDimensions = getElementDimensionsOnResize(true, []),
    _getElementDimensions2 = Spinner_slicedToArray(_getElementDimensions, 2),
    dimensions = _getElementDimensions2[0],
    containerRef = _getElementDimensions2[1];
  var relativeSize = 0.5;
  var lowestDim = Math.min((_a = dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) !== null && _a !== void 0 ? _a : 0, (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) !== null && _b !== void 0 ? _b : 0);
  var lowestDimCss = "".concat(Math.round(lowestDim * relativeSize), "px");
  return (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
    "class": "spinner__container",
    ref: containerRef
  }, {
    children: (0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "spinner",
      style: {
        width: lowestDimCss,
        height: lowestDimCss
      }
    })
  }));
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageEditorLayout.scss
var ImageEditorLayout = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageEditorLayout.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageEditorLayout.scss

      
      
      
      
      
      
      
      
      

var ImageEditorLayout_options = {};

ImageEditorLayout_options.styleTagTransform = (styleTagTransform_default());
ImageEditorLayout_options.setAttributes = (setAttributesWithoutAttributes_default());
ImageEditorLayout_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
ImageEditorLayout_options.domAPI = (styleDomAPI_default());
ImageEditorLayout_options.insertStyleElement = (insertStyleElement_default());

var ImageEditorLayout_update = injectStylesIntoStyleTag_default()(ImageEditorLayout["default"], ImageEditorLayout_options);




       /* harmony default export */ var editors_ImageEditorLayout = (ImageEditorLayout["default"] && ImageEditorLayout["default"].locals ? ImageEditorLayout["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageEditorLayout.tsx
function ImageEditorLayout_slicedToArray(arr, i) { return ImageEditorLayout_arrayWithHoles(arr) || ImageEditorLayout_iterableToArrayLimit(arr, i) || ImageEditorLayout_unsupportedIterableToArray(arr, i) || ImageEditorLayout_nonIterableRest(); }
function ImageEditorLayout_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ImageEditorLayout_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ImageEditorLayout_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageEditorLayout_arrayLikeToArray(o, minLen); }
function ImageEditorLayout_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ImageEditorLayout_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ImageEditorLayout_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







var ImageEditorLayout_ImageEditorLayout = function ImageEditorLayout(_ref) {
  var actions = _ref.actions,
    originalImage = _ref.originalImage,
    header = _ref.header,
    image = _ref.image,
    modal = _ref.modal;
  var _useState = (0,compat_namespaceObject.useState)(""),
    _useState2 = ImageEditorLayout_slicedToArray(_useState, 2),
    imageUrl = _useState2[0],
    setImageUrl = _useState2[1];
  // Used to determine whether to show the image element or the spinner.
  var _useState3 = (0,compat_namespaceObject.useState)(false),
    _useState4 = ImageEditorLayout_slicedToArray(_useState3, 2),
    imageLoaded = _useState4[0],
    setImageLoaded = _useState4[1];
  // Used to track if the image element is 'loaded' per its onload state.
  var _useState5 = (0,compat_namespaceObject.useState)(false),
    _useState6 = ImageEditorLayout_slicedToArray(_useState5, 2),
    imageLoadedReal = _useState6[0],
    setImageLoadedReal = _useState6[1];
  var _useState7 = (0,compat_namespaceObject.useState)("upload-widget__image-editor__image-".concat(Math.round(Math.random() * 100000))),
    _useState8 = ImageEditorLayout_slicedToArray(_useState7, 1),
    containerId = _useState8[0];
  var _getElementDimensions = getElementDimensionsOnParentResize(imageLoadedReal, [imageUrl, imageLoaded]),
    _getElementDimensions2 = ImageEditorLayout_slicedToArray(_getElementDimensions, 3),
    imgDimensions = _getElementDimensions2[0],
    imgRef = _getElementDimensions2[1],
    containerRef = _getElementDimensions2[2];
  // When multiple images are uploaded, the same component instance is used, so we need to update the image with an effect:
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    var _calculateImagePrevie = calculateImagePreviewUrl(originalImage),
      url = _calculateImagePrevie.url,
      external = _calculateImagePrevie.external;
    setImageUrl(url);
    setImageLoaded(!external); // Delay for displaying a local image is very short, so don't flash the loader to the user.
    setImageLoadedReal(false); // Image will be unloaded to being with, as we're changing its "src" attribute here.
  }, [originalImage.fileUrl]);
  return (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
    className: "upload-widget__image-editor"
  }, {
    children: [(0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      className: external_classnames_default()({
        "upload-widget__image-editor__header": header !== undefined,
        "upload-widget__image-editor__header--empty-non-modal": header === undefined && !modal
      })
    }, {
      children: header
    })), (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      className: "upload-widget__image-editor__image",
      ref: containerRef
    }, {
      children: (0,jsx_runtime_namespaceObject.jsxs)("div", Object.assign({
        className: "upload-widget__image-editor__image-padding"
      }, {
        children: [!imageLoaded && (0,jsx_runtime_namespaceObject.jsx)(Spinner_Spinner, {}), (0,jsx_runtime_namespaceObject.jsx)("img", {
          id: containerId,
          src: imageUrl,
          onLoad: function onLoad() {
            setImageLoaded(true);
            setImageLoadedReal(true);
          },
          className: "upload-widget__image-editor__image-inner",
          style: imageLoaded ? {} : {
            display: "none"
          },
          ref: imgRef,
          draggable: false
        }), imgDimensions !== undefined && imageLoaded && image !== undefined && image({
          imgDimensions: imgDimensions,
          imageUrl: imageUrl
        })]
      }))
    })), (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      className: "upload-widget__image-editor__actions upload-widget__controls upload-widget__controls--space"
    }, {
      children: actions
    }))]
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageEditorHeader.tsx

var getImageEditorHeader = function getImageEditorHeader(_ref) {
  var imageCount = _ref.imageCount,
    imageIndex = _ref.imageIndex,
    options = _ref.options;
  var locale = options.locale;
  var multi = options.multi ? {
    imageIndex: imageIndex,
    imageCount: imageCount
  } : undefined;
  return multi === undefined || multi.imageCount === 1 ? undefined : (0,jsx_runtime_namespaceObject.jsxs)("span", Object.assign({
    className: "text-secondary"
  }, {
    children: [locale.imageCropNumberPrefix, " ", multi.imageIndex + 1, " ", locale.xOfY, " ", multi.imageCount]
  }));
};
;// CONCATENATED MODULE: ./src/modules/FormUtils.ts
function FormUtils_slicedToArray(arr, i) { return FormUtils_arrayWithHoles(arr) || FormUtils_iterableToArrayLimit(arr, i) || FormUtils_unsupportedIterableToArray(arr, i) || FormUtils_nonIterableRest(); }
function FormUtils_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function FormUtils_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return FormUtils_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FormUtils_arrayLikeToArray(o, minLen); }
function FormUtils_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function FormUtils_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function FormUtils_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var transientFlagTimeout = 1500;
function useTransientFlag() {
  var _useState = (0,compat_namespaceObject.useState)(undefined),
    _useState2 = FormUtils_slicedToArray(_useState, 2),
    onTimeout = _useState2[0],
    setOnTimeout = _useState2[1];
  var flag = onTimeout !== undefined;
  (0,compat_namespaceObject.useEffect)(function () {
    if (onTimeout !== undefined) {
      var handle = setTimeout(function () {
        setOnTimeout(undefined);
        onTimeout();
      }, transientFlagTimeout);
      return function () {
        return clearTimeout(handle);
      };
    }
    return function () {};
  }, [flag]);
  return [flag, function (onTimeout) {
    return setOnTimeout(onTimeout !== null && onTimeout !== void 0 ? onTimeout : function () {});
  }];
}
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/buttons/SubmitButton.tsx
function SubmitButton_slicedToArray(arr, i) { return SubmitButton_arrayWithHoles(arr) || SubmitButton_iterableToArrayLimit(arr, i) || SubmitButton_unsupportedIterableToArray(arr, i) || SubmitButton_nonIterableRest(); }
function SubmitButton_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function SubmitButton_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return SubmitButton_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubmitButton_arrayLikeToArray(o, minLen); }
function SubmitButton_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function SubmitButton_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function SubmitButton_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var SubmitButton = function SubmitButton(_ref) {
  var busyText = _ref.busyText,
    idleText = _ref.idleText,
    locale = _ref.locale,
    onSubmit = _ref.onSubmit,
    showIcon = _ref.showIcon;
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = SubmitButton_slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useTransientFlag = useTransientFlag(),
    _useTransientFlag2 = SubmitButton_slicedToArray(_useTransientFlag, 2),
    isError = _useTransientFlag2[0],
    setIsError = _useTransientFlag2[1];
  var isDisabled = isSubmitting || isError;
  var submitAsync = function submitAsync(e) {
    e.preventDefault();
    setIsSubmitting(true);
    onSubmit().then(function () {}, function (e) {
      console.error(e);
      setIsError();
      setIsSubmitting(false);
    });
  };
  return (0,jsx_runtime_namespaceObject.jsxs)("button", Object.assign({
    disabled: isDisabled,
    onClick: submitAsync,
    className: external_classnames_default()("btn btn--primary", {
      disabled: isDisabled
    })
  }, {
    children: [isSubmitting ? busyText : isError ? locale.submitBtnError : idleText, " ", showIcon && (0,jsx_runtime_namespaceObject.jsx)(RightSvg, {
      width: 12,
      className: "ml-2"
    })]
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageEditorButtons.tsx


function ImageEditorButtons_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function ImageEditorButtons_async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var ImageEditorButtons = function ImageEditorButtons(_ref) {
  var options = _ref.options,
    onFinish = _ref.onFinish;
  var locale = options.locale;
  return (0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [(0,jsx_runtime_namespaceObject.jsx)("button", Object.assign({
      onClick: function onClick() {
        onFinish(false).then(function () {}, function (e) {
          console.error("Unable to cancel upload.", e);
        });
      },
      className: "btn"
    }, {
      children: locale.cancelPreviewBtn
    })), (0,jsx_runtime_namespaceObject.jsx)(SubmitButton, {
      onSubmit: ImageEditorButtons_async(function () {
        return onFinish(true);
      }),
      locale: locale,
      idleText: locale.continueBtn,
      busyText: locale.submitBtnLoading,
      showIcon: false
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageCropper.scss
var ImageCropper = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/components/widgets/uploadWidget/components/editors/ImageCropper.scss");
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageCropper.scss

      
      
      
      
      
      
      
      
      

var ImageCropper_options = {};

ImageCropper_options.styleTagTransform = (styleTagTransform_default());
ImageCropper_options.setAttributes = (setAttributesWithoutAttributes_default());
ImageCropper_options.insert = function insertIntoTarget(element) {
        if (typeof document !== "undefined") {
          document.head.appendChild(element);
        }
      };
ImageCropper_options.domAPI = (styleDomAPI_default());
ImageCropper_options.insertStyleElement = (insertStyleElement_default());

var ImageCropper_update = injectStylesIntoStyleTag_default()(ImageCropper["default"], ImageCropper_options);




       /* harmony default export */ var editors_ImageCropper = (ImageCropper["default"] && ImageCropper["default"].locals ? ImageCropper["default"].locals : undefined);

;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageCropper.tsx
function ImageCropper_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _empty() {}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function ImageCropper_async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function ImageCropper_slicedToArray(arr, i) { return ImageCropper_arrayWithHoles(arr) || ImageCropper_iterableToArrayLimit(arr, i) || ImageCropper_unsupportedIterableToArray(arr, i) || ImageCropper_nonIterableRest(); }
function ImageCropper_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ImageCropper_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ImageCropper_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageCropper_arrayLikeToArray(o, minLen); }
function ImageCropper_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ImageCropper_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ImageCropper_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










function makeCropJson(originalFilePathRelative, geometry, boundary, nativeImageSize) {
  var scale = nativeImageSize.width / boundary.width;
  return {
    inputPath: originalFilePathRelative,
    pipeline: {
      steps: [{
        geometry: {
          offset: {
            x: Math.round(geometry.x * scale),
            y: Math.round(geometry.y * scale)
          },
          size: {
            width: Math.round(geometry.width * scale),
            height: Math.round(geometry.height * scale),
            type: "widthxheight!"
          }
        },
        type: "crop"
      }]
    }
  };
}
var ImageCropper_ImageCropper = function ImageCropper(props) {
  var options = props.options,
    originalImage = props.originalImage,
    upload = props.upload,
    onFinish = props.onFinish;
  var _useState = (0,compat_namespaceObject.useState)(undefined),
    _useState2 = ImageCropper_slicedToArray(_useState, 2),
    geometry = _useState2[0],
    setGeometry = _useState2[1];
  var submit = ImageCropper_async(function (keep) {
    var _a;
    return _invokeIgnored(function () {
      if (!keep || geometry === undefined) {
        onFinish(keep, undefined);
      } else {
        return ImageCropper_await(new Promise(function (resolve) {
          var _a;
          var img = new Image();
          var imgInfo = calculateImagePreviewUrl(originalImage);
          img.onload = function () {
            resolve({
              width: img.naturalWidth,
              height: img.naturalHeight
            });
          };
          img.src = (_a = imgInfo.urlForDimensions) !== null && _a !== void 0 ? _a : imgInfo.url;
        }), function (nativeImageSize) {
          var originalImageUploadedName = originalImage.filePath.substring(originalImage.filePath.lastIndexOf("/") + 1);
          var cropJson = makeCropJson(originalImageUploadedName, geometry.geometry, geometry.boundary, nativeImageSize);
          var blob = new Blob([JSON.stringify(cropJson)], {
            type: "application/json"
          });
          var tags = options.tags,
            metadata = options.metadata;
          return ImageCropper_await(upload.uploadFile({
            name: "".concat((_a = originalImage.originalFileName) !== null && _a !== void 0 ? _a : "image", ".crop"),
            type: blob.type,
            size: blob.size,
            slice: function slice(start, end) {
              return blob.slice(start, end);
            }
          }, {
            path: options.editor.images.cropFilePath(originalImage),
            // When uploading crops, users expect the crop file to be treated the same as the original image (e.g. when adding expiration rules to images).
            metadata: metadata,
            tags: tags
          }), function (editedFile) {
            onFinish(keep, editedFile);
          });
        });
      }
    });
  });
  return (0,jsx_runtime_namespaceObject.jsx)(ImageEditorLayout_ImageEditorLayout, {
    modal: options.layout === "modal",
    header: getImageEditorHeader(props),
    actions: (0,jsx_runtime_namespaceObject.jsx)(ImageEditorButtons, {
      options: options,
      onFinish: submit
    }),
    image: function image(_ref) {
      var imgDimensions = _ref.imgDimensions,
        imageUrl = _ref.imageUrl;
      var _a, _b, _c, _d;
      return (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
        className: "upload-widget__image-cropper__overlay",
        style: RectWithPos.toCssProps(imgDimensions)
      }, {
        children: (0,jsx_runtime_namespaceObject.jsx)(ResizableSquare_ResizableSquare, Object.assign({
          boundary: imgDimensions,
          onResized: setGeometry,
          ratio: options.editor.images.cropRatio,
          allowResizeOnMove: options.editor.images.allowResizeOnMove
        }, {
          children: (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
            className: external_classnames_default()("upload-widget__image-cropper__clip", {
              "upload-widget__image-cropper__clip--circular": options.editor.images.cropShape === "circ"
            }),
            style: {
              width: (_a = geometry === null || geometry === void 0 ? void 0 : geometry.geometry.width) !== null && _a !== void 0 ? _a : imgDimensions.width,
              height: (_b = geometry === null || geometry === void 0 ? void 0 : geometry.geometry.height) !== null && _b !== void 0 ? _b : imgDimensions.height
            }
          }, {
            children: (0,jsx_runtime_namespaceObject.jsx)("img", {
              src: imageUrl,
              draggable: false,
              style: {
                width: imgDimensions.width,
                height: imgDimensions.height,
                transform: "translateX(".concat(((_c = geometry === null || geometry === void 0 ? void 0 : geometry.geometry.x) !== null && _c !== void 0 ? _c : 0) * -1, "px) translateY(").concat(((_d = geometry === null || geometry === void 0 ? void 0 : geometry.geometry.y) !== null && _d !== void 0 ? _d : 0) * -1, "px)")
              }
            })
          }))
        }))
      }));
    },
    originalImage: originalImage
  });
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImagePreview.tsx





function ImagePreview_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function ImagePreview_async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var ImagePreview = function ImagePreview(props) {
  var options = props.options,
    originalImage = props.originalImage,
    onFinish = props.onFinish;
  var submit = ImagePreview_async(function (keep) {
    onFinish(keep);
    return ImagePreview_await();
  });
  return (0,jsx_runtime_namespaceObject.jsx)(ImageEditorLayout_ImageEditorLayout, {
    modal: options.layout === "modal",
    header: getImageEditorHeader(props),
    actions: (0,jsx_runtime_namespaceObject.jsx)(ImageEditorButtons, {
      options: options,
      onFinish: submit
    }),
    originalImage: originalImage
  });
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/components/editors/ImageEditor.tsx




function canCropImage(options, originalImage) {
  return options.editor.images.crop && isEditableImage(originalImage);
}
var ImageEditor = function ImageEditor(_ref) {
  var imageCount = _ref.imageCount,
    imageIndex = _ref.imageIndex,
    originalImage = _ref.originalImage,
    upload = _ref.upload,
    onImageEdited = _ref.onImageEdited,
    options = _ref.options;
  // Currently we only provide a cropper: it would be good to provide rotation in the future, too, and we can switch between
  // them here.
  return canCropImage(options, originalImage) ? (0,jsx_runtime_namespaceObject.jsx)(ImageCropper_ImageCropper, {
    imageCount: imageCount,
    imageIndex: imageIndex,
    options: options,
    onFinish: onImageEdited,
    upload: upload,
    originalImage: originalImage
  }) : (0,jsx_runtime_namespaceObject.jsx)(ImagePreview, {
    imageCount: imageCount,
    imageIndex: imageIndex,
    options: options,
    onFinish: function onFinish(keep) {
      return onImageEdited(keep, undefined);
    },
    originalImage: originalImage
  });
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/modules/UseImageList.ts
function UseImageList_toConsumableArray(arr) { return UseImageList_arrayWithoutHoles(arr) || UseImageList_iterableToArray(arr) || UseImageList_unsupportedIterableToArray(arr) || UseImageList_nonIterableSpread(); }
function UseImageList_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseImageList_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function UseImageList_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return UseImageList_arrayLikeToArray(arr); }
function UseImageList_slicedToArray(arr, i) { return UseImageList_arrayWithHoles(arr) || UseImageList_iterableToArrayLimit(arr, i) || UseImageList_unsupportedIterableToArray(arr, i) || UseImageList_nonIterableRest(); }
function UseImageList_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseImageList_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UseImageList_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UseImageList_arrayLikeToArray(o, minLen); }
function UseImageList_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UseImageList_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UseImageList_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useImageList(images) {
  var _useState = (0,compat_namespaceObject.useState)(images[0]),
    _useState2 = UseImageList_slicedToArray(_useState, 2),
    currentImage = _useState2[0],
    setCurrentImage = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(0),
    _useState4 = UseImageList_slicedToArray(_useState3, 2),
    imageIndex = _useState4[0],
    setImageIndex = _useState4[1];
  var _useState5 = (0,compat_namespaceObject.useState)(images.length),
    _useState6 = UseImageList_slicedToArray(_useState5, 2),
    imageCount = _useState6[0],
    setImageCount = _useState6[1];
  var editingFiles = images.map(function (x) {
    return x.uploadedFile.filePath;
  });
  var currentFile = currentImage.uploadedFile.filePath;
  // Prevents image being swapped-out mid-edit if an upload that was started _before_ this image finishes _after_ this
  // image has uploaded.
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    var hasFinishedEditing = !editingFiles.includes(currentFile);
    if (hasFinishedEditing) {
      setCurrentImage(images[0]);
      setImageIndex(function (i) {
        return i + 1;
      });
    }
    setImageCount(imageIndex + images.length);
  }, [imageIndex, currentFile].concat(UseImageList_toConsumableArray(editingFiles)));
  return {
    currentFile: currentFile,
    imageCount: imageCount,
    imageIndex: imageIndex,
    currentImage: currentImage
  };
}
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/UploaderImageListEditor.tsx



var UploaderImageListEditor = function UploaderImageListEditor(_ref) {
  var images = _ref.images,
    _onImageEdited = _ref.onImageEdited,
    upload = _ref.upload,
    options = _ref.options;
  var _useImageList = useImageList(images),
    currentFile = _useImageList.currentFile,
    imageCount = _useImageList.imageCount,
    imageIndex = _useImageList.imageIndex,
    currentImage = _useImageList.currentImage;
  return (0,jsx_runtime_namespaceObject.jsx)(ImageEditor, {
    options: options,
    imageCount: imageCount,
    imageIndex: imageIndex,
    originalImage: currentImage.uploadedFile,
    onImageEdited: function onImageEdited(keep, editedFile) {
      return _onImageEdited(keep, editedFile, currentImage.fileIndex);
    },
    upload: upload
  }, currentFile);
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/screens/modules/UseShowImageEditor.ts
function UseShowImageEditor_slicedToArray(arr, i) { return UseShowImageEditor_arrayWithHoles(arr) || UseShowImageEditor_iterableToArrayLimit(arr, i) || UseShowImageEditor_unsupportedIterableToArray(arr, i) || UseShowImageEditor_nonIterableRest(); }
function UseShowImageEditor_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseShowImageEditor_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UseShowImageEditor_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UseShowImageEditor_arrayLikeToArray(o, minLen); }
function UseShowImageEditor_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UseShowImageEditor_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UseShowImageEditor_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useShowImageEditor(pendingImages, onFileUploadDelay) {
  var _useState = (0,compat_namespaceObject.useState)(false),
    _useState2 = UseShowImageEditor_slicedToArray(_useState, 2),
    showImageScreen = _useState2[0],
    setShowImageScreen = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(null),
    _useState4 = UseShowImageEditor_slicedToArray(_useState3, 2),
    showImageScreenTimeout = _useState4[0],
    setShowImageScreenTimeout = _useState4[1];
  (0,compat_namespaceObject.useEffect)(function () {
    if (pendingImages.length > 0) {
      var timeout = setTimeout(function () {
        setShowImageScreen(true);
      }, onFileUploadDelay);
      setShowImageScreenTimeout(timeout);
      return function () {
        return clearTimeout(timeout);
      };
    }
    if (showImageScreen) {
      setShowImageScreen(false);
    }
    if (showImageScreenTimeout !== null) {
      clearTimeout(showImageScreenTimeout);
      setShowImageScreenTimeout(null);
    }
  }, [pendingImages.length, showImageScreen]);
  return showImageScreen;
}
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/UploadWidget.tsx
function UploadWidget_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
function _continue(value, then) {
  return value && value.then ? value.then(then) : then(value);
}
function UploadWidget_async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function UploadWidget_toConsumableArray(arr) { return UploadWidget_arrayWithoutHoles(arr) || UploadWidget_iterableToArray(arr) || UploadWidget_unsupportedIterableToArray(arr) || UploadWidget_nonIterableSpread(); }
function UploadWidget_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadWidget_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function UploadWidget_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return UploadWidget_arrayLikeToArray(arr); }
function UploadWidget_slicedToArray(arr, i) { return UploadWidget_arrayWithHoles(arr) || UploadWidget_iterableToArrayLimit(arr, i) || UploadWidget_unsupportedIterableToArray(arr, i) || UploadWidget_nonIterableRest(); }
function UploadWidget_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadWidget_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UploadWidget_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UploadWidget_arrayLikeToArray(o, minLen); }
function UploadWidget_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UploadWidget_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UploadWidget_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var UploadWidget_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};















function inferMimeType(fileName) {
  var _a, _b;
  var ext = ((_a = fileName.split(".").pop()) !== null && _a !== void 0 ? _a : "").trim().toLowerCase();
  var fallback = "application/octet-stream";
  // These are popular file types that some browser+OSs don't recognise (so return "" for the file.type), meaning
  // we need to lookup the extension ourselves. In the future, it would be a good idea to over an API endpoint to
  // perform this resolution (so that we can hold a more extensive dataset, without increasing bundle size).
  var commonUnsupportedExtensions = {
    heic: "image/heic",
    heif: "image/heif"
  };
  return (_b = commonUnsupportedExtensions[ext]) !== null && _b !== void 0 ? _b : fallback;
}
function isValidMimeType(allowedMimeTypes, file) {
  var _a;
  if (allowedMimeTypes === undefined || allowedMimeTypes.length === 0) {
    return true;
  }
  // Some browsers/OSs return "" as the MIME type for unknown MIME types (e.g. HEIC on some devices is reported like this).
  var actualMimeType = (_a = file.type === "" ? undefined : file.type) !== null && _a !== void 0 ? _a : inferMimeType(file.name);
  var normalize = function normalize(x) {
    return x.trim().toLowerCase();
  };
  var actualNormalized = normalize(actualMimeType);
  return allowedMimeTypes.some(function (x) {
    var requiredNormalized = normalize(x);
    return requiredNormalized === actualNormalized || requiredNormalized.endsWith("*") && actualNormalized.startsWith(requiredNormalized.substring(0, requiredNormalized.length - 1));
  });
}
var UploadWidget = function UploadWidget(_ref) {
  var resolve = _ref.resolve,
    options = _ref.options,
    upload = _ref.upload;
  var _a;
  var _useState = (0,compat_namespaceObject.useState)(0),
    _useState2 = UploadWidget_slicedToArray(_useState, 2),
    setNextSparseFileIndex = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(true),
    _useState4 = UploadWidget_slicedToArray(_useState3, 2),
    isInitialUpdate = _useState4[0],
    setIsInitialUpdate = _useState4[1];
  var _useState5 = (0,compat_namespaceObject.useState)({}),
    _useState6 = UploadWidget_slicedToArray(_useState5, 2),
    submittedFiles = _useState6[0],
    setSubmittedFiles = _useState6[1];
  var submittedFileList = Object.values(submittedFiles).filter(isDefined);
  var uploadedFiles = submittedFileList.filter(isUploadedFile);
  var pendingFiles = submittedFileList.filter(isPendingFile);
  var failedFiles = submittedFileList.filter(isFailedFile);
  var makeDeps = function makeDeps(fileLists) {
    return [].concat(UploadWidget_toConsumableArray(fileLists.map(function (x) {
      return x.length;
    })), UploadWidget_toConsumableArray(fileLists.flatMap(function (x) {
      return x.map(function (y) {
        return y.fileIndex;
      });
    })));
  };
  var onFileUploadDelay = progressWheelDelay + (progressWheelVanish - 100); // Allows the animation to finish before closing modal. We add some time to allow the wheel to fade out.
  var multi = options.multi,
    tags = options.tags,
    metadata = options.metadata,
    path = options.path;
  var uploadedFilesReady = uploadedFiles.filter(function (x) {
    return x.isReady;
  });
  var uploadedFilesNotReady = uploadedFiles.filter(function (x) {
    return !x.isReady;
  }); // These will be previewable or editable media files.
  var uploadedFilesReadyResult = uploadedFilesReady.map(function (x) {
    return UploadWidgetResult.from(x.uploadedFile, x.editedFile);
  });
  var canEditImages = options.editor.images.crop;
  var canPreviewImages = options.editor.images.preview;
  var fileRequiresUserInteraction = function fileRequiresUserInteraction(uploadedFile) {
    return (canEditImages || canPreviewImages) && isEditableImage(uploadedFile) || canPreviewImages && isReadOnlyImage(uploadedFile);
  };
  var showImageEditor = useShowImageEditor(uploadedFilesNotReady, onFileUploadDelay);
  var onFileReady = function onFileReady(keepFile, editedFile, sparseFileIndex) {
    if (!keepFile) {
      removeSubmittedFile(sparseFileIndex);
    } else {
      updateFile(sparseFileIndex, "uploaded", function (file) {
        return Object.assign(Object.assign({}, file), {
          editedFile: editedFile,
          isReady: true
        });
      });
    }
  };
  var finalize = function finalize() {
    resolve(uploadedFilesReadyResult);
  };
  // We want to use a 'layout effect' since if the cropper has just been closed in 'single file mode', we want to
  // immediately resolve the Upload Widget, rather than momentarily showing the main screen.
  (0,compat_namespaceObject.useLayoutEffect)(function () {
    if (isInitialUpdate) {
      setIsInitialUpdate(false);
      return;
    }
    options.onUpdate({
      failedFiles: failedFiles.map(function (_ref2) {
        var file = _ref2.file,
          error = _ref2.error;
        return {
          file: file,
          error: error
        };
      }),
      uploadedFiles: uploadedFilesReadyResult,
      pendingFiles: [].concat(UploadWidget_toConsumableArray(pendingFiles), UploadWidget_toConsumableArray(uploadedFilesNotReady)).map(function (_ref3) {
        var file = _ref3.file;
        return {
          file: file
        };
      })
    });
    // For inline layouts, if in single-file mode, we never resolve (there is no terminal state): we just allow the
    // user to add/remove their file, and the caller should instead rely on the 'onUpdate' method above.
    var shouldCloseModalImmediatelyAfterUpload = !multi && uploadedFilesReady.length > 0 && !options.showFinishButton && options.layout === "modal";
    if (shouldCloseModalImmediatelyAfterUpload) {
      // Just in case the user dragged-and-dropped multiple files.
      var firstUploadedFile = uploadedFilesReadyResult.slice(0, 1);
      var doResolve = function doResolve() {
        return resolve(firstUploadedFile);
      };
      var previousScreenWasEditor = fileRequiresUserInteraction(uploadedFiles[0].uploadedFile);
      if (previousScreenWasEditor) {
        doResolve();
      } else {
        var timeout = setTimeout(doResolve, onFileUploadDelay);
        return function () {
          return clearTimeout(timeout);
        };
      }
    }
  }, makeDeps([pendingFiles, uploadedFilesNotReady, uploadedFilesReady, failedFiles]));
  var removeSubmittedFile = function removeSubmittedFile(fileIndex) {
    setSubmittedFiles(function (x) {
      var _a = x,
        _b = fileIndex,
        removed = _a[_b],
        rest = UploadWidget_rest(_a, [_typeof(_b) === "symbol" ? _b : _b + ""]);
      if ((removed === null || removed === void 0 ? void 0 : removed.type) === "uploading") {
        removed.cancel();
      }
      return rest;
    });
  };
  var setSubmittedFile = function setSubmittedFile(fileIndex, file) {
    setSubmittedFiles(function (x) {
      return Object.assign(Object.assign({}, x), _defineProperty({}, fileIndex, file));
    });
  };
  var updateFile = function updateFile(fileIndex, fileType, file) {
    setSubmittedFiles(function (x) {
      var oldFile = x[fileIndex];
      if (oldFile === undefined || oldFile.type !== fileType) {
        return x;
      }
      return Object.assign(Object.assign({}, x), _defineProperty({}, fileIndex, file(oldFile)));
    });
  };
  var doUpload = UploadWidget_async(function (file, fileIndex) {
    var _a, _b;
    var raiseValidationError = function raiseValidationError(errorMessage) {
      var error = new UploadWidgetValidationError(errorMessage);
      setSubmittedFile(fileIndex, {
        file: file,
        fileIndex: fileIndex,
        error: error,
        type: "failed"
      });
      throw error;
    };
    var maxFileSizeBytes = options.maxFileSizeBytes,
      mimeTypes = options.mimeTypes,
      onPreUpload = options.onPreUpload;
    if (maxFileSizeBytes !== undefined && file.size > maxFileSizeBytes) {
      raiseValidationError("".concat(options.locale.fileSizeLimitPrefix, " ").concat(humanFileSize(maxFileSizeBytes)));
    }
    if (!isValidMimeType(mimeTypes, file)) {
      raiseValidationError(options.locale.unsupportedFileType);
    }
    setSubmittedFile(fileIndex, {
      file: file,
      fileIndex: fileIndex,
      type: "preprocessing"
    });
    var preUploadResult;
    return _continue(_catch(function () {
      return UploadWidget_await(onPreUpload(file), function (_onPreUpload) {
        preUploadResult = (_a = _onPreUpload) !== null && _a !== void 0 ? _a : undefined;
      }); // incase the user returns 'null' instead of undefined.
    }, function (e) {
      preUploadResult = {
        errorMessage: options.locale.customValidationFailed
      };
      console.error("[upload-widget] onPreUpload function raised an error.", e);
    }), function () {
      if ((preUploadResult === null || preUploadResult === void 0 ? void 0 : preUploadResult.errorMessage) !== undefined) {
        raiseValidationError(preUploadResult.errorMessage);
      }
      var fileToUpload = (_b = preUploadResult === null || preUploadResult === void 0 ? void 0 : preUploadResult.transformedFile) !== null && _b !== void 0 ? _b : file;
      return UploadWidget_await(upload.uploadFile(fileToUpload, {
        path: path,
        metadata: metadata,
        tags: tags,
        onBegin: function onBegin(_ref4) {
          var cancel = _ref4.cancel;
          return setSubmittedFile(fileIndex, {
            // IMPORTANT: use 'setSubmittedFile' as file may already exist in collection as a "validating" file.
            file: fileToUpload,
            fileIndex: fileIndex,
            cancel: cancel,
            progress: 0,
            type: "uploading"
          });
        },
        onProgress: function onProgress(_ref5) {
          var bytesSent = _ref5.bytesSent,
            bytesTotal = _ref5.bytesTotal;
          return updateFile(fileIndex, "uploading", function (uploadingFile) {
            return Object.assign(Object.assign({}, uploadingFile), {
              progress: bytesSent / bytesTotal
            });
          });
        }
      }));
    });
  });
  var addFiles = function addFiles(files) {
    return setNextSparseFileIndex(function (nextSparseFileIndex) {
      var maxFiles = multi ? options.maxFileCount : 1;
      var filesToTake = maxFiles === undefined ? files.length : Math.min(files.length, maxFiles - submittedFileList.length);
      // Ignores subsequent drag-and-drop events for single file uploaders.
      if (filesToTake <= 0) {
        return nextSparseFileIndex;
      }
      files.slice(0, filesToTake).forEach(function (file, i) {
        var fileIndex = nextSparseFileIndex + i;
        doUpload(file, fileIndex).then(function (uploadedFile) {
          updateFile(fileIndex, "uploading", function () {
            return {
              file: file,
              fileIndex: fileIndex,
              uploadedFile: uploadedFile,
              editedFile: undefined,
              isReady: !fileRequiresUserInteraction(uploadedFile),
              type: "uploaded"
            };
          });
        }, function (error) {
          updateFile(fileIndex, "uploading", function (uploadingFile) {
            return {
              fileIndex: fileIndex,
              error: error,
              file: uploadingFile.file,
              type: "failed"
            };
          });
        });
      });
      return nextSparseFileIndex + files.length;
    });
  };
  var _b = useDragDrop(addFiles),
    isDragging = _b.isDragging,
    rootProps = UploadWidget_rest(_b, ["isDragging"]);
  var mimeTypes = (_a = options.mimeTypes) !== null && _a !== void 0 ? _a : [];
  var isImageUploader = mimeTypes.length > 0 && mimeTypes.every(function (x) {
    return x.trim().toLowerCase().startsWith("image/");
  });
  return (0,jsx_runtime_namespaceObject.jsx)(UploadWidgetInternal_UploadWidgetInternal, Object.assign({
    htmlProps: rootProps,
    isDraggable: true,
    isDragging: isDragging,
    layout: options.layout,
    multi: options.multi
  }, {
    children: submittedFileList.length === 0 ? (0,jsx_runtime_namespaceObject.jsx)(UploaderWelcomeScreen, {
      options: options,
      addFiles: addFiles,
      isImageUploader: isImageUploader
    }) : showImageEditor && uploadedFilesNotReady.length > 0 ? (0,jsx_runtime_namespaceObject.jsx)(UploaderImageListEditor, {
      images: uploadedFilesNotReady,
      onImageEdited: onFileReady,
      upload: upload,
      options: options
    }) : (0,jsx_runtime_namespaceObject.jsx)(UploaderMainScreen_UploaderMainScreen, {
      options: options,
      addFiles: addFiles,
      submittedFiles: submittedFileList,
      uploadedFiles: uploadedFiles,
      remove: removeSubmittedFile,
      finalize: finalize,
      isImageUploader: isImageUploader
    })
  }));
};
;// CONCATENATED MODULE: ./src/components/widgets/uploadWidget/UploadWidgetContainer.tsx

// Put this first, so other components' stylesheets can override the default styles.



var UploadWidgetContainer_UploadWidgetContainer = function UploadWidgetContainer(_ref) {
  var upload = _ref.upload,
    resolve = _ref.resolve,
    reject = _ref.reject,
    options = _ref.options;
  return (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
    children: upload.type === "error" ? (0,jsx_runtime_namespaceObject.jsx)(ConfigError, {
      error: upload.value,
      layout: options.layout
    }) : (0,jsx_runtime_namespaceObject.jsx)(UploadWidget, {
      resolve: resolve,
      reject: reject,
      options: options,
      upload: upload.value
    })
  });
};
;// CONCATENATED MODULE: ./src/components/modal/ModalContainer.tsx
function ModalContainer_slicedToArray(arr, i) { return ModalContainer_arrayWithHoles(arr) || ModalContainer_iterableToArrayLimit(arr, i) || ModalContainer_unsupportedIterableToArray(arr, i) || ModalContainer_nonIterableRest(); }
function ModalContainer_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ModalContainer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ModalContainer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ModalContainer_arrayLikeToArray(o, minLen); }
function ModalContainer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ModalContainer_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ModalContainer_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var ModalContainer = function ModalContainer(_ref) {
  var widgetProps = _ref.widgetProps;
  // NEVER call without resolving or rejecting the promise, as will cause a hanging promise.
  var _useState = (0,compat_namespaceObject.useState)(true),
    _useState2 = ModalContainer_slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var resolve = function resolve(files) {
    widgetProps.resolve(files);
    setIsOpen(false);
  };
  var reject = function reject(error) {
    widgetProps.reject(error);
    setIsOpen(false);
  };
  if (!isOpen) {
    return (0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {});
  }
  return (0,jsx_runtime_namespaceObject.jsx)(Modal_Modal, Object.assign({
    closeModal: function closeModal() {
      return resolve([]);
    }
  }, {
    children: (0,jsx_runtime_namespaceObject.jsx)(UploadWidgetContainer_UploadWidgetContainer, Object.assign({}, widgetProps, {
      resolve: resolve,
      reject: reject
    }))
  }));
};
;// CONCATENATED MODULE: ./src/components/RootContainer.tsx
function RootContainer_slicedToArray(arr, i) { return RootContainer_arrayWithHoles(arr) || RootContainer_iterableToArrayLimit(arr, i) || RootContainer_unsupportedIterableToArray(arr, i) || RootContainer_nonIterableRest(); }
function RootContainer_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function RootContainer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RootContainer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RootContainer_arrayLikeToArray(o, minLen); }
function RootContainer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function RootContainer_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function RootContainer_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var RootContainer = function RootContainer(_ref) {
  var widgetProps = _ref.widgetProps;
  var _useState = (0,compat_namespaceObject.useState)(0),
    _useState2 = RootContainer_slicedToArray(_useState, 2),
    refreshKey = _useState2[0],
    setRefreshKey = _useState2[1];
  var _useState3 = (0,compat_namespaceObject.useState)(widgetProps.options),
    _useState4 = RootContainer_slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _getElementDimensions = getElementDimensionsOnResize(true, []),
    _getElementDimensions2 = RootContainer_slicedToArray(_getElementDimensions, 2),
    dimensions = _getElementDimensions2[0],
    containerRef = _getElementDimensions2[1];
  var widgetPropsUpdated = Object.assign(Object.assign({}, widgetProps), {
    options: options
  });
  (0,compat_namespaceObject.useEffect)(function () {
    options.onInit({
      close: function close() {
        widgetProps.resolve([]);
      },
      reset: function reset() {
        setRefreshKey(function (x) {
          return x + 1;
        });
        if (widgetProps.upload.type === "success") {
          widgetProps.upload.value.cancelAll();
        }
      },
      updateConfig: function updateConfig(newOptionsPartial) {
        setOptions(UploadWidgetConfigRequired.from(newOptionsPartial));
      }
    });
  }, []);
  var isFullScreen = dimensions !== undefined && (dimensions.width <= options.styles.breakpoints.fullScreenWidth || dimensions.height <= options.styles.breakpoints.fullScreenHeight);
  return (0,jsx_runtime_namespaceObject.jsx)(external_preact_namespaceObject.Fragment, {
    children: (0,jsx_runtime_namespaceObject.jsx)("div", Object.assign({
      ref: containerRef,
      className: external_classnames_default()("upload-widget", {
        "upload-widget--with-modal": options.layout === "modal",
        "upload-widget--full-screen": isFullScreen
      }),
      style: {
        "--error-color": options.styles.colors.error,
        "--primary-color": options.styles.colors.primary,
        "--primary-active-color": options.styles.colors.active,
        "--shade-100": options.styles.colors.shade100,
        "--shade-200": options.styles.colors.shade200,
        "--shade-300": options.styles.colors.shade300,
        "--shade-400": options.styles.colors.shade400,
        "--shade-500": options.styles.colors.shade500,
        "--shade-600": options.styles.colors.shade600,
        "--shade-700": options.styles.colors.shade700,
        "--shade-800": options.styles.colors.shade800,
        "--shade-900": options.styles.colors.shade900,
        "--base-font-family": options.styles.fontFamilies.base,
        "--base-font-size": "".concat(options.styles.fontSizes.base, "px")
      }
    }, {
      children: options.layout === "modal" ? (0,jsx_runtime_namespaceObject.jsx)(ModalContainer, {
        widgetProps: widgetPropsUpdated
      }) : (0,jsx_runtime_namespaceObject.jsx)(UploadWidgetContainer_UploadWidgetContainer, Object.assign({}, widgetPropsUpdated))
    }))
  }, refreshKey);
};
;// CONCATENATED MODULE: ./src/modules/UploadTracker.ts
function UploadTracker_typeof(o) { "@babel/helpers - typeof"; return UploadTracker_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UploadTracker_typeof(o); }
function UploadTracker_toConsumableArray(arr) { return UploadTracker_arrayWithoutHoles(arr) || UploadTracker_iterableToArray(arr) || UploadTracker_unsupportedIterableToArray(arr) || UploadTracker_nonIterableSpread(); }
function UploadTracker_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadTracker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UploadTracker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UploadTracker_arrayLikeToArray(o, minLen); }
function UploadTracker_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function UploadTracker_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return UploadTracker_arrayLikeToArray(arr); }
function UploadTracker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UploadTracker_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _rethrow(thrown, value) {
  if (thrown) throw value;
  return value;
}
function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }
  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }
  return finalizer(false, result);
}
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, UploadTracker_toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function UploadTracker_toPropertyKey(t) { var i = UploadTracker_toPrimitive(t, "string"); return "symbol" == UploadTracker_typeof(i) ? i : i + ""; }
function UploadTracker_toPrimitive(t, r) { if ("object" != UploadTracker_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UploadTracker_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/**
 * Allows all file uploads to be cancelled (e.g. when widget closes).
 */
var UploadTracker = /*#__PURE__*/function () {
  function UploadTracker(config) {
    _classCallCheck(this, UploadTracker);
    this.config = config;
    this.uploadCancellations = [];
    this.uploadManager = new sdk_namespaceObject.UploadManager(config);
  }
  return _createClass(UploadTracker, [{
    key: "cancelAll",
    value: function cancelAll() {
      this.uploadCancellations.forEach(function (cancel) {
        return cancel();
      });
      this.uploadCancellations = [];
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file, request) {
      try {
        var _this = this;
        var _a;
        var cancel;
        return _finallyRethrows(function () {
          var cancellationToken = (_a = request.cancellationToken) !== null && _a !== void 0 ? _a : {
            isCancelled: false
          };
          cancel = function cancel() {
            cancellationToken.isCancelled = true;
          };
          _this.uploadCancellations = [].concat(UploadTracker_toConsumableArray(_this.uploadCancellations), [cancel]);
          if (request.onBegin !== undefined) {
            request.onBegin({
              cancel: cancel
            });
          }
          return UploadTracker_await(_this.uploadManager.upload(Object.assign(Object.assign({}, request), {
            cancellationToken: cancellationToken,
            data: file
          })), function (fileDetails) {
            return Object.assign(Object.assign({}, fileDetails), {
              file: file
            });
          });
        }, function (_wasThrown, _result) {
          _this.uploadCancellations = _this.uploadCancellations.filter(function (x) {
            return x !== cancel;
          });
          return _rethrow(_wasThrown, _result);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);
}();
;// CONCATENATED MODULE: ./src/UploadWidget.tsx
function UploadWidget_typeof(o) { "@babel/helpers - typeof"; return UploadWidget_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UploadWidget_typeof(o); }
function src_UploadWidget_await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function UploadWidget_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function UploadWidget_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, UploadWidget_toPropertyKey(descriptor.key), descriptor); } }
function UploadWidget_createClass(Constructor, protoProps, staticProps) { if (protoProps) UploadWidget_defineProperties(Constructor.prototype, protoProps); if (staticProps) UploadWidget_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function UploadWidget_toPropertyKey(t) { var i = UploadWidget_toPrimitive(t, "string"); return "symbol" == UploadWidget_typeof(i) ? i : i + ""; }
function UploadWidget_toPrimitive(t, r) { if ("object" != UploadWidget_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UploadWidget_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var UploadWidget_UploadWidget = /*#__PURE__*/function () {
  function UploadWidget() {
    UploadWidget_classCallCheck(this, UploadWidget);
  }
  return UploadWidget_createClass(UploadWidget, null, [{
    key: "open",
    value: function open(optionsMaybe) {
      try {
        var _a;
        var uploadTracker;
        try {
          uploadTracker = {
            type: "success",
            value: new UploadTracker(optionsMaybe)
          };
        } catch (e) {
          uploadTracker = {
            type: "error",
            value: e
          };
        }
        var options = UploadWidgetConfigRequired.from(optionsMaybe);
        // Important: wait for body first, before using 'querySelector' below.
        return src_UploadWidget_await(UploadWidget.getBody(), function (body) {
          var container = options.container !== undefined ? typeof options.container === "string" ? (_a = document.querySelector(options.container)) !== null && _a !== void 0 ? _a : undefined : options.container : undefined;
          var widget = document.createElement("div");
          (container !== null && container !== void 0 ? container : body).appendChild(widget);
          // Do not refer to 'options' in this file (where possible): move to 'RootContainer' so that it can handle prop updates.
          widget.className = "upload-widget__root";
          return src_UploadWidget_await(new Promise(function (resolve, reject) {
            var props = {
              upload: uploadTracker,
              resolve: resolve,
              reject: reject,
              options: options
            };
            (0,external_preact_namespaceObject.render)((0,jsx_runtime_namespaceObject.jsx)(RootContainer, {
              widgetProps: props
            }), widget);
          }), function (uploadedFiles) {
            widget.remove();
            if (uploadTracker.type === "success") {
              uploadTracker.value.cancelAll(); // Stops in-progress uploads when the widget is closed.
            }
            return uploadedFiles;
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
    /**
     * Required when the 'uploadWidget.open()' method is called from within '<head>'.
     */
  }, {
    key: "getBody",
    value: function getBody() {
      try {
        return src_UploadWidget_await(new Promise(function (resolve) {
          var attempt = function attempt() {
            var _a;
            var bodyMaybe = (_a = document.body) !== null && _a !== void 0 ? _a : undefined;
            if (bodyMaybe !== undefined) {
              resolve(bodyMaybe);
            }
            setTimeout(attempt, 100);
          };
          attempt();
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);
}();
;// CONCATENATED MODULE: ./src/model/UploadWidgetValidationError.ts
function UploadWidgetValidationError_typeof(o) { "@babel/helpers - typeof"; return UploadWidgetValidationError_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UploadWidgetValidationError_typeof(o); }
function UploadWidgetValidationError_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, UploadWidgetValidationError_toPropertyKey(descriptor.key), descriptor); } }
function UploadWidgetValidationError_createClass(Constructor, protoProps, staticProps) { if (protoProps) UploadWidgetValidationError_defineProperties(Constructor.prototype, protoProps); if (staticProps) UploadWidgetValidationError_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function UploadWidgetValidationError_toPropertyKey(t) { var i = UploadWidgetValidationError_toPrimitive(t, "string"); return "symbol" == UploadWidgetValidationError_typeof(i) ? i : i + ""; }
function UploadWidgetValidationError_toPrimitive(t, r) { if ("object" != UploadWidgetValidationError_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UploadWidgetValidationError_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function UploadWidgetValidationError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (UploadWidgetValidationError_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var UploadWidgetValidationError = /*#__PURE__*/function (_Error) {
  function UploadWidgetValidationError(message) {
    var _this;
    UploadWidgetValidationError_classCallCheck(this, UploadWidgetValidationError);
    _this = _callSuper(this, UploadWidgetValidationError, [message]);
    _this.name = "UploadWidgetValidationError";
    return _this;
  }
  _inherits(UploadWidgetValidationError, _Error);
  return UploadWidgetValidationError_createClass(UploadWidgetValidationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
;// CONCATENATED MODULE: ./src/index.ts




}();
module.exports = __webpack_exports__;
/******/ })()
;